window.TCB_FINDER_DATA = window.TCB_FINDER_DATA || {};

window.TCB_FINDER_DATA.products = [
  {
    "id": "walk-behind-floor-scrubbers",
    "name": "Walk-Behind Floor Scrubbers",
    "url": "/collections/walk-behind-floor-scrubbers",
    "type": "product-category",
    "bestFor": [
      "hard_floors",
      "school",
      "office",
      "restaurant",
      "gym",
      "small_medium",
      "5000_25000",
      "floor_scrubber"
    ]
  },
  {
    "id": "ride-on-floor-scrubbers",
    "name": "Ride-On Floor Scrubbers",
    "url": "/collections/rider-floor-scrubbers",
    "type": "product-category",
    "bestFor": [
      "hard_floors",
      "warehouse",
      "large",
      "75000_plus",
      "multiple",
      "25000_75000"
    ]
  },
  {
    "id": "floor-scrubbers",
    "name": "Floor Scrubbers",
    "url": "/collections/floor-scrubbers",
    "type": "product-category",
    "bestFor": [
      "hard_floors",
      "entire_facility",
      "floor_scrubber",
      "not_sure"
    ]
  },
  {
    "id": "sweepers",
    "name": "Sweepers",
    "url": "/collections/floor-sweepers",
    "type": "product-category",
    "bestFor": [
      "warehouse_concrete",
      "warehouse",
      "dust",
      "debris",
      "sweeper"
    ]
  },
  {
    "id": "wet-dry-vacuums",
    "name": "Wet/Dry Vacuums",
    "url": "/collections/commercial-vacuums",
    "type": "product-category",
    "bestFor": [
      "wet_dry",
      "warehouse_concrete",
      "warehouse",
      "restrooms",
      "greasy_floors",
      "1000_3000",
      "under_1000"
    ]
  },
  {
    "id": "commercial-vacuums",
    "name": "Commercial Vacuums",
    "url": "/collections/commercial-vacuums",
    "type": "product-category",
    "bestFor": [
      "office_spaces",
      "commercial_vacuum",
      "wet_dry",
      "school",
      "church",
      "hotel",
      "contractor",
      "under_1000",
      "1000_3000"
    ]
  },
  {
    "id": "carpet-extractors",
    "name": "Carpet Extractors",
    "url": "/collections/carpet-extractors",
    "type": "product-category",
    "bestFor": [
      "carpet",
      "carpet_extractor",
      "hotel",
      "property_manager",
      "church",
      "contractor"
    ]
  },
  {
    "id": "floor-buffers",
    "name": "Floor Buffers",
    "url": "/collections/buffers-burnishers",
    "type": "product-category",
    "bestFor": [
      "hard_floors",
      "floor_buffer",
      "floor_care",
      "school",
      "office"
    ]
  },
  {
    "id": "burnishers",
    "name": "Burnishers",
    "url": "/collections/buffers-burnishers",
    "type": "product-category",
    "bestFor": [
      "hard_floors",
      "burnisher",
      "floor_shine",
      "office",
      "school"
    ]
  },
  {
    "id": "industrial-cleaning-equipment",
    "name": "Industrial Cleaning Equipment",
    "url": "/collections/shop-all-equipment",
    "type": "product-category",
    "bestFor": [
      "warehouse",
      "industrial",
      "warehouse_concrete",
      "large",
      "entire_facility",
      "75000_plus"
    ]
  },
  {
    "id": "parts",
    "name": "Replacement Parts",
    "url": "/collections/shop-all-parts",
    "type": "product-category",
    "bestFor": [
      "parts",
      "replacement_parts",
      "maintenance"
    ]
  },
  {
    "id": "chemicals",
    "name": "Chemicals & Supplies",
    "url": "/collections/cleaning-chemicals",
    "type": "product-category",
    "bestFor": [
      "chemicals",
      "greasy_floors",
      "restrooms",
      "carpet",
      "supplies",
      "under_1000"
    ]
  },
  {
    "id": "machine-tennant-t20-industrial-ride-on-floor-scrubber-80-gallon",
    "name": "Tennant® T20 Industrial Ride-On Floor Scrubber w/ ES® Extended Scrub & ec-H2O™ T",
    "url": "https://thecleaningbusiness.com/products/tennant-t20-industrial-ride-on-floor-scrubber-80-gallon",
    "type": "product",
    "price": 81884,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tennant-t20-front.jpg?v=1782337993",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "entire_facility",
      "hard_floors"
    ]
  },
  {
    "id": "machine-tennant-t16-automatic-floor-scrubber",
    "name": "Tennant® T16 36\" Ride-On Automatic Floor Scrubber w/ ec-H2O™ Technology (Disk Sc",
    "url": "https://thecleaningbusiness.com/products/tennant-t16-automatic-floor-scrubber",
    "type": "product",
    "price": 45921,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tennant-t16-front.jpg?v=1782338023",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "entire_facility",
      "hard_floors"
    ]
  },
  {
    "id": "machine-outdoor-gas-powered-ride-on-sweeper",
    "name": "IPC Eagle Genius 58\" Outdoor Gas Powered Ride On Sweeper",
    "url": "https://thecleaningbusiness.com/products/outdoor-gas-powered-ride-on-sweeper",
    "type": "product",
    "price": 40225,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-genius-1404-ride-on-sweeper.jpg?v=1782338054",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "sweeper",
      "warehouse",
      "warehouse_concrete",
      "entire_facility",
      "hard_floors"
    ]
  },
  {
    "id": "machine-battery-operated-ride-on-airport-sweeper",
    "name": "IPC Eagle 1404 Battery Operated Ride On Vacuum Sweeper - 58\" Sweeping Path",
    "url": "https://thecleaningbusiness.com/products/battery-operated-ride-on-airport-sweeper",
    "type": "product",
    "price": 38015,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-genius-1404-ride-on-sweeper_1.jpg?v=1782338080",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "sweeper",
      "warehouse",
      "warehouse_concrete",
      "entire_facility",
      "hard_floors"
    ]
  },
  {
    "id": "machine-advancer-sw4000tm-rider-sweeper",
    "name": "Advance® SW4000™ Rider Sweeper - 49\" Sweeping Path",
    "url": "https://thecleaningbusiness.com/products/advancer-sw4000tm-rider-sweeper",
    "type": "product",
    "price": 36532,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/advancer-sw4000tm-rider-sweeper-49.jpg?v=1782338114",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "sweeper",
      "warehouse",
      "warehouse_concrete",
      "entire_facility",
      "hard_floors"
    ]
  },
  {
    "id": "machine-26-34-tvl-850-t-compact-ride-on-adjustable-auto-scrubber-lithium-phosphate-32-ga-4",
    "name": "26\" - 34\" TVL 850/T Compact Ride-On Adjustable Auto Scrubber - Lithium Phosphate",
    "url": "https://www.thecleaningbusiness.com/products/26-34-tvl-850-t-compact-ride-on-adjustable-auto-scrubber-lithium-phosphate-32-ga-4",
    "type": "product",
    "price": 30556.9,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/TVL850_150TRide-onScrubber_f12b8dff-8248-4131-90fc-24efe9b23277.jpg?v=1782495472",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "entire_facility",
      "hard_floors"
    ]
  },
  {
    "id": "machine-26-34-tvl-850-t-compact-ride-on-adjustable-auto-scrubber-lithium-phosphate-32-ga-3",
    "name": "26\" - 34\" TVL 850/T Compact Ride-On Adjustable Auto Scrubber - Lithium Phosphate",
    "url": "https://www.thecleaningbusiness.com/products/26-34-tvl-850-t-compact-ride-on-adjustable-auto-scrubber-lithium-phosphate-32-ga-3",
    "type": "product",
    "price": 29016.9,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/TVL850_150TRide-onScrubber_889309c8-0e32-4215-a01c-b9e7851a0bca.jpg?v=1782495488",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "entire_facility",
      "hard_floors"
    ]
  },
  {
    "id": "machine-tennant-r14-rider-self-contained-carpet-cleaning-extractor",
    "name": "Tennant® R14 Rider Self-Contained Carpet Cleaning Extractor (32 Gallons) - 28\" H",
    "url": "https://thecleaningbusiness.com/products/tennant-r14-rider-self-contained-carpet-cleaning-extractor",
    "type": "product",
    "price": 28871,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tennant-r14-ride-on-carpet-cleaning-extractor.jpg?v=1782338145",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "carpet",
      "carpet_extractor",
      "entire_facility"
    ]
  },
  {
    "id": "machine-26-34-tvl-850-t-compact-ride-on-adjustable-auto-scrubber-lithium-phosphate-32-ga-2",
    "name": "26\" - 34\" TVL 850/T Compact Ride-On Adjustable Auto Scrubber - Lithium Phosphate",
    "url": "https://www.thecleaningbusiness.com/products/26-34-tvl-850-t-compact-ride-on-adjustable-auto-scrubber-lithium-phosphate-32-ga-2",
    "type": "product",
    "price": 27916.9,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/TVL850_150TRide-onScrubber_f061d4f3-4452-4b76-b1cc-a800b875878c.jpg?v=1782495558",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "entire_facility",
      "hard_floors"
    ]
  },
  {
    "id": "machine-tennant-t7-ride-on-automatic-floor-scrubber",
    "name": "Tennant® T7 Ride-On Automatic Floor Scrubber w/ Conventional & ec-H2O NanoClean®",
    "url": "https://thecleaningbusiness.com/products/tennant-t7-ride-on-automatic-floor-scrubber",
    "type": "product",
    "price": 27678,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tennant-t7-front.jpg?v=1782338174",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "entire_facility",
      "hard_floors"
    ]
  },
  {
    "id": "machine-clarke-focus-ii-34-disc-rider-autoscrubber-clk-56114031",
    "name": "Clarke Focus II 34\" Disc Rider Autoscrubber",
    "url": "https://www.thecleaningbusiness.com/products/clarke-focus-ii-34-disc-rider-autoscrubber-clk-56114031",
    "type": "product",
    "price": 26758,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Clarke-Focus-II-Rider-Autoscrubber-sm.jpg?v=1782184713",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "entire_facility",
      "hard_floors"
    ]
  },
  {
    "id": "machine-advance-sc4000-ride-on-floor-scrubber",
    "name": "Advance® SC4000® Ride-On Floor Scrubber w/ REV Technology (Battery, EcoFlex™ & H",
    "url": "https://thecleaningbusiness.com/products/advance-sc4000-ride-on-floor-scrubber",
    "type": "product",
    "price": 26659,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/sc4000-advance-floor-scrubber-lg.jpg?v=1782338202",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "entire_facility",
      "hard_floors"
    ]
  },
  {
    "id": "machine-26-34-tvl-850-t-compact-ride-on-adjustable-auto-scrubber-lithium-phosphate-32-gal-tvl-85",
    "name": "26\" - 34\" TVL 850/T Compact Ride-On Adjustable Auto Scrubber - Lithium Phosphate",
    "url": "https://www.thecleaningbusiness.com/products/26-34-tvl-850-t-compact-ride-on-adjustable-auto-scrubber-lithium-phosphate-32-gal-tvl-85",
    "type": "product",
    "price": 26376.9,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/TVL850_150TRide-onScrubber_36c4a730-c4b5-4206-a728-8473d6659065.jpg?v=1782495538",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "entire_facility",
      "hard_floors"
    ]
  },
  {
    "id": "machine-advance-advenger-ride-on-floor-scrubber-with-rev-technology",
    "name": "28\" Advance® Advenger® Ride-On Floor Scrubber w/ REV Technology",
    "url": "https://thecleaningbusiness.com/products/advance-advenger-ride-on-floor-scrubber-with-rev-technology",
    "type": "product",
    "price": 25290,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/advance-advenger-with-ecoflex.jpg?v=1782338225",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "entire_facility",
      "hard_floors"
    ]
  },
  {
    "id": "machine-focus-ii-28-boost-rider-autoscrubber-clk-56114020",
    "name": "Focus II 28\" BOOST Rider Autoscrubber",
    "url": "https://www.thecleaningbusiness.com/products/focus-ii-28-boost-rider-autoscrubber-clk-56114020",
    "type": "product",
    "price": 24922,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Focus-II-Boost-Rider-Auto-Srubber-sm.jpg?v=1782184723",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "entire_facility",
      "hard_floors"
    ]
  },
  {
    "id": "machine-ipc-eagle-1280-battery-power-rider-sweeper",
    "name": "IPC Eagle 1280 Battery Powered Rider Vacuum Sweeper - 48\" Sweeping Path",
    "url": "https://thecleaningbusiness.com/products/ipc-eagle-1280-battery-power-rider-sweeper",
    "type": "product",
    "price": 24894,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/1280-battery-powered-rider-sweeper.jpg?v=1782338249",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "sweeper",
      "warehouse",
      "warehouse_concrete",
      "entire_facility",
      "hard_floors"
    ]
  },
  {
    "id": "machine-36-inch-automatic-ride-on-scrubber",
    "name": "IPC Eagle CT160 Industrial Automatic Ride On Floor Scrubber (36\" Scrub Deck) - 3",
    "url": "https://thecleaningbusiness.com/products/36-inch-automatic-ride-on-scrubber",
    "type": "product",
    "price": 24701,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-ct160-automatic-ride-on-scrubber_1_1.jpg?v=1782338278",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "entire_facility",
      "hard_floors"
    ]
  },
  {
    "id": "machine-clarke-focus-ii-28-disc-rider-autoscrubber-clk-56114012",
    "name": "Clarke Focus II 28\" Disc Rider Autoscrubber",
    "url": "https://www.thecleaningbusiness.com/products/clarke-focus-ii-28-disc-rider-autoscrubber-clk-56114012",
    "type": "product",
    "price": 24660,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Clarke-Focus-II-Rider-Autoscrubber-sm_6fe0b00b-882a-404d-959c-82e40cad033d.jpg?v=1782184733",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "entire_facility",
      "hard_floors"
    ]
  },
  {
    "id": "machine-clarke-focus-ii-boost-automatic-ride-on-floor-scrubber",
    "name": "Clarke® Focus® II BOOST® Automatic Ride on Floor Scrubber",
    "url": "https://thecleaningbusiness.com/products/clarke-focus-ii-boost-automatic-ride-on-floor-scrubber",
    "type": "product",
    "price": 24660,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/clarke-focus-ii-boost-automatic-ride-on-floor-scrubber_2.jpg?v=1782338303",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "entire_facility",
      "hard_floors"
    ]
  },
  {
    "id": "machine-tennant-t600-self-propelled-walk-behind-floor-scrubber",
    "name": "Tennant® T600 Self-Propelled Walk Behind Automatic Floor Scrubber w/ Pad Drivers",
    "url": "https://thecleaningbusiness.com/products/tennant-t600-self-propelled-walk-behind-floor-scrubber",
    "type": "product",
    "price": 23423,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tennant-t600-walk-behind-floor-scrubber-2.jpg?v=1782357854",
    "bestFor": [
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus",
      "75000_plus",
      "professional",
      "entire_facility"
    ]
  },
  {
    "id": "machine-pacific-floorcare-rs28-rider-scrubber-with-deck-option",
    "name": "Pacific Floorcare® RS28 Ride On Automatic Floor Scrubber (28\" Disc or 14\" x 28\" ",
    "url": "https://thecleaningbusiness.com/products/pacific-floorcare-rs28-rider-scrubber-with-deck-option",
    "type": "product",
    "price": 22865.97,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/pacific-floorcare-rs28-rider-scrubber.jpg?v=1782338333",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "entire_facility",
      "hard_floors"
    ]
  },
  {
    "id": "machine-advance-terra-4300b-compact-rider-sweeper",
    "name": "Advance Terra® 4300B Compact Rider Sweeper - 46\" Sweeping Path",
    "url": "https://thecleaningbusiness.com/products/advance-terra-4300b-compact-rider-sweeper",
    "type": "product",
    "price": 22626,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/advance-terra-4300b-compact-rider-sweeper-46-inch.jpg?v=1782338358",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "sweeper",
      "warehouse",
      "warehouse_concrete",
      "entire_facility",
      "hard_floors"
    ]
  },
  {
    "id": "machine-scrubmaster-b120-ride-on-floor-scrubber-financing-available-33-cylindrical-sm3332cqp-284",
    "name": "Scrubmaster B120 Ride On Floor Scrubber | Financing Available - 33\" Cylindrical ",
    "url": "https://www.thecleaningbusiness.com/products/scrubmaster-b120-ride-on-floor-scrubber-financing-available-33-cylindrical-sm3332cqp-284",
    "type": "product",
    "price": 22368.6,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/120-left_MINUTEMAN-scaled.jpg?v=1782495617",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "entire_facility",
      "hard_floors"
    ]
  },
  {
    "id": "machine-scrubmaster-b120-ride-on-floor-scrubber-financing-available-28-cylindrical-sm2832cqp-284",
    "name": "Scrubmaster B120 Ride On Floor Scrubber | Financing Available - 28\" Cylindrical ",
    "url": "https://www.thecleaningbusiness.com/products/scrubmaster-b120-ride-on-floor-scrubber-financing-available-28-cylindrical-sm2832cqp-284",
    "type": "product",
    "price": 22107.48,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/120-left_MINUTEMAN-scaled_41933db3-a927-4648-9279-ac6955870b5d.jpg?v=1782495586",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "entire_facility",
      "hard_floors"
    ]
  },
  {
    "id": "machine-green-cleaning-rider-scrubber",
    "name": "IPC Eagle CT110 ECS Low Moisture Rider Floor Scrubber (32\" Scrub Deck) - 29 Gall",
    "url": "https://thecleaningbusiness.com/products/green-cleaning-rider-scrubber",
    "type": "product",
    "price": 21256,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-ct110ecs-low-moisture-rider-scrubber.jpg?v=1782338388",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "entire_facility",
      "hard_floors"
    ]
  },
  {
    "id": "machine-scrubmaster-b120-ride-on-floor-scrubber-financing-available-35-disc-sm3532dqp-28406",
    "name": "Scrubmaster B120 Ride On Floor Scrubber | Financing Available - 35\" Disc (SM3532",
    "url": "https://www.thecleaningbusiness.com/products/scrubmaster-b120-ride-on-floor-scrubber-financing-available-35-disc-sm3532dqp-28406",
    "type": "product",
    "price": 20843.7,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/120-left_MINUTEMAN-scaled_69e9daf5-c7c6-4846-a90d-240b03364905.jpg?v=1782495690",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "entire_facility",
      "hard_floors"
    ]
  },
  {
    "id": "machine-torando-bd-33-30-rider-auto-scrubber-w-pad-drivers",
    "name": "Torando® BD 33/30 Rider Auto Scrubber w/ Pad Drivers",
    "url": "https://thecleaningbusiness.com/products/torando-bd-33-30-rider-auto-scrubber-w-pad-drivers",
    "type": "product",
    "price": 20841,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tornado-bd-33-30-disc-rider-scrubber-99780c.jpg?v=1782357884",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "entire_facility",
      "hard_floors"
    ]
  },
  {
    "id": "machine-kleen-sweep-47r-ride-on-floor-sweeper-large-area-vacuum-financing-available-base-unit-wi",
    "name": "Kleen Sweep 47R Ride On Floor Sweeper - Large Area Vacuum | Financing Available ",
    "url": "https://www.thecleaningbusiness.com/products/kleen-sweep-47r-ride-on-floor-sweeper-large-area-vacuum-financing-available-base-unit-wi",
    "type": "product",
    "price": 20793.89,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/KleenSweep47R1.png?v=1782495712",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "sweeper",
      "warehouse",
      "warehouse_concrete",
      "entire_facility",
      "hard_floors"
    ]
  },
  {
    "id": "machine-focus-ii-28-boost-microrider-autoscrubber-clk-56382630",
    "name": "Focus II 28\" BOOST MicroRider Autoscrubber",
    "url": "https://www.thecleaningbusiness.com/products/focus-ii-28-boost-microrider-autoscrubber-clk-56382630",
    "type": "product",
    "price": 20660,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Focus-II-Boost-MicroRider-Auto-Scrubber-sm.jpg?v=1782184743",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "entire_facility",
      "hard_floors"
    ]
  },
  {
    "id": "machine-scrubmaster-b120-ride-on-floor-scrubber-financing-available-30-disc-sm3032dqp-28405",
    "name": "Scrubmaster B120 Ride On Floor Scrubber | Financing Available - 30\" Disc (SM3032",
    "url": "https://www.thecleaningbusiness.com/products/scrubmaster-b120-ride-on-floor-scrubber-financing-available-30-disc-sm3032dqp-28405",
    "type": "product",
    "price": 20615.22,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/120-left_MINUTEMAN-scaled_6cff5ad0-2516-41d6-92f8-aa09b2cf0833.jpg?v=1782495741",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "entire_facility",
      "hard_floors"
    ]
  },
  {
    "id": "machine-pioneer-eclipse-28-inch-350bu-battery-floor-burnisher",
    "name": "Pioneer Eclipse 28\" 350BU High Speed Battery Floor Burnisher - 2,000 RPM",
    "url": "https://thecleaningbusiness.com/products/pioneer-eclipse-28-inch-350bu-battery-floor-burnisher",
    "type": "product",
    "price": 19969.24,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/pioneer-eclipse-350BU-28inch-battery-burnisher.jpg?v=1782338418",
    "bestFor": [
      "7500_15000",
      "15000_plus",
      "hard_floors"
    ]
  },
  {
    "id": "machine-focus-ii-26-disc-microrider-autoscrubber-clk-56382626",
    "name": "Focus II 26\" Disc MicroRider Autoscrubber",
    "url": "https://www.thecleaningbusiness.com/products/focus-ii-26-disc-microrider-autoscrubber-clk-56382626",
    "type": "product",
    "price": 19020,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Focus-II-Disc-MicroRider-Auto-Scrubber-sm.jpg?v=1782184753",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-clarke-focus-ii-microrider-auto-scrubber",
    "name": "Clarke® Focus® II MicroRider™ Auto Floor Scrubber (26\" or 14\" x 28\" Deck Options",
    "url": "https://thecleaningbusiness.com/products/clarke-focus-ii-microrider-auto-scrubber",
    "type": "product",
    "price": 19020,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/clarke-focus-2-microrider-auto-scrubber-with-disk-deck.jpg?v=1782338449",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-advance-adgressor-3220d-industrial-32-inch-ride-on-floor-scrubber",
    "name": "Advance® Adgressor® 3220D Industrial 32\" Ride on Floor Scrubber - 42 Gallon",
    "url": "https://thecleaningbusiness.com/products/advance-adgressor-3220d-industrial-32-inch-ride-on-floor-scrubber",
    "type": "product",
    "price": 18818,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/advance-adgressor-rider-floor-scrubber-56384766.jpg?v=1782338477",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-nilfisk-sw3000-li-ion-ride-on-industrial-floor-sweeper",
    "name": "Nilfisk® SW3000™ Ride-On Industrial Floor Sweeper w/ Li-Ion Batteries - 53\" Swee",
    "url": "https://thecleaningbusiness.com/products/nilfisk-sw3000-li-ion-ride-on-industrial-floor-sweeper",
    "type": "product",
    "price": 18563,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/nilfisk-sw3000-li-ion-industrial-sweeper.webp?v=1782338506",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "sweeper",
      "warehouse",
      "warehouse_concrete",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-clarke-clean-track-l24-battery-powered-self-contained-carpet-extractor",
    "name": "Clarke® Clean Track® L24 Battery Powered Self-Contained Carpet Extractor",
    "url": "https://thecleaningbusiness.com/products/clarke-clean-track-l24-battery-powered-self-contained-carpet-extractor",
    "type": "product",
    "price": 18363,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/clarke-clean-track-l24-carpet-extractor-rt.jpg?v=1782338534",
    "bestFor": [
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "7500_15000"
    ]
  },
  {
    "id": "machine-large-ride-on-automatic-floor-scrubber",
    "name": "IPC Eagle CT110 Compact Ride-On Automatic Floor Scrubber (32\" Scrub Deck) - 29 G",
    "url": "https://thecleaningbusiness.com/products/large-ride-on-automatic-floor-scrubber",
    "type": "product",
    "price": 18330,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-ct110bt85-32-inch-rider-floor-scrubber.jpg?v=1782338561",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-battery-powered-rider-warehouse-sweeper",
    "name": "IPC Eagle 1050 Battery Powered Rider Warehouse Vacuum Sweeper - 42\" Sweeping Pat",
    "url": "https://thecleaningbusiness.com/products/battery-powered-rider-warehouse-sweeper",
    "type": "product",
    "price": 17767,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-1050-battery-powered-rider-sweeper.jpg?v=1782338580",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "sweeper",
      "warehouse",
      "warehouse_concrete",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-aquaplus-axp-battery-powered-self-contained-carpet-extractor-by-advance",
    "name": "Advance® AquaPLUS™ AXP™ Battery Powered Self-Contained Carpet Extractor",
    "url": "https://thecleaningbusiness.com/products/aquaplus-axp-battery-powered-self-contained-carpet-extractor-by-advance",
    "type": "product",
    "price": 17706,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/aquaplus-axp-advance-extractor.jpg?v=1782338609",
    "bestFor": [
      "carpet",
      "carpet_extractor",
      "15000_plus",
      "7500_15000"
    ]
  },
  {
    "id": "machine-viper-as850r-312-rider-auto-scrubber-32-cleaning-path-vp-as850r-312",
    "name": "Viper AS850R-312 Rider Auto Scrubber - 32\" Cleaning Path",
    "url": "https://www.thecleaningbusiness.com/products/viper-as850r-312-rider-auto-scrubber-32-cleaning-path-vp-as850r-312",
    "type": "product",
    "price": 17239,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/AS850R-OBC-242-sm.jpg?v=1782184763",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-advance-sc800-st-34-inch-battery-floor-scrubber",
    "name": "Advance® SC800™ ST 34\" Battery Powered Floor Scrubber w/ Pad Holders",
    "url": "https://thecleaningbusiness.com/products/advance-sc800-st-34-inch-battery-floor-scrubber",
    "type": "product",
    "price": 16988,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/advance-sc750-st-scrubber_1.jpg?v=1782357905",
    "bestFor": [
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus"
    ]
  },
  {
    "id": "machine-viper-as850r-242-rider-auto-scrubber-32-cleaning-path-vp-as850r-242",
    "name": "Viper AS850R-242 Rider Auto Scrubber - 32\" Cleaning Path",
    "url": "https://www.thecleaningbusiness.com/products/viper-as850r-242-rider-auto-scrubber-32-cleaning-path-vp-as850r-242",
    "type": "product",
    "price": 16466,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/AS850R-OBC-242-sm_8d38a144-1fae-490a-bf4c-60e26eee475e.jpg?v=1782184773",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-viper-as850r-32-inch-rider-automatic-floor-scrubber",
    "name": "Viper AS850R 32\" Rider Automatic Floor Scrubber - 32 Gallons",
    "url": "https://thecleaningbusiness.com/products/viper-as850r-32-inch-rider-automatic-floor-scrubber",
    "type": "product",
    "price": 16466,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/viper-as850r-32-inch-rider-scrubber-main.jpg?v=1782338627",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-viper-as710r-ride-on-auto-floor-scrubber-28-cleaning-path-vp-as710r",
    "name": "Viper AS710R Ride On Auto Floor Scrubber - 28\" Cleaning Path",
    "url": "https://www.thecleaningbusiness.com/products/viper-as710r-ride-on-auto-floor-scrubber-28-cleaning-path-vp-as710r",
    "type": "product",
    "price": 16227,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/AS430C-Electric-Automatic-Floor-Scrubber-sm.jpg?v=1782184783",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-viper-ros1300-ride-on-sweeper",
    "name": "Viper ROS1300 Rider Floor Sweeper w/ Dust Control - 53\" Sweeping Path",
    "url": "https://thecleaningbusiness.com/products/viper-ros1300-ride-on-sweeper",
    "type": "product",
    "price": 16007,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ros1300-viper-ride-on-sweeper.jpg?v=1782338653",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "sweeper",
      "warehouse",
      "warehouse_concrete",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-tennant-t500e-26-inch-walk-behind-floor-scrubber",
    "name": "Tennant® T500e Self-Propelled 26\" Walk Behind Automatic Floor Scrubber w/ Pad Dr",
    "url": "https://thecleaningbusiness.com/products/tennant-t500e-26-inch-walk-behind-floor-scrubber",
    "type": "product",
    "price": 15992,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tennant-t500e-26-inch-walk-behind-floor-scrubber.jpg?v=1782357920",
    "bestFor": [
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus"
    ]
  },
  {
    "id": "machine-advance-sc750-28-inch-battery-floor-scrubber-w-pad-holders",
    "name": "Advance® SC750™ 28\" Battery Floor Scrubber w/ Pad Holders",
    "url": "https://thecleaningbusiness.com/products/advance-sc750-28-inch-battery-floor-scrubber-w-pad-holders",
    "type": "product",
    "price": 15836,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/advance-sc750-28-inch-scrubber.jpg?v=1782357928",
    "bestFor": [
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus"
    ]
  },
  {
    "id": "machine-advance-sc901-28-inch-commercial-battery-floor-scrubber-w-pad-driver",
    "name": "Advance® SC901™ 28\" Commercial Battery Floor Scrubber w/ Pad Driver",
    "url": "https://thecleaningbusiness.com/products/advance-sc901-28-inch-commercial-battery-floor-scrubber-w-pad-driver",
    "type": "product",
    "price": 15721,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/sc900-advance-floor-scrubber.jpg?v=1782357934",
    "bestFor": [
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus"
    ]
  },
  {
    "id": "machine-clarke-focus-boost-28-inch-orbital-auto-scrubber",
    "name": "Clarke® Focus® II Boost® 14\" x 28\" Orbital Auto Floor Scrubber",
    "url": "https://thecleaningbusiness.com/products/clarke-focus-boost-28-inch-orbital-auto-scrubber",
    "type": "product",
    "price": 15548,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/clarke-focus-2-boost-14-x-28-inch-orbital-auto-floor-scrubber.jpg?v=1782338675",
    "bestFor": [
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus"
    ]
  },
  {
    "id": "machine-pacific-floorcare-s-28-orbital-floor-scrubber-14x28",
    "name": "Pacific Floorcare® S-28 Orbital Automatic Floor Scrubber (22 Gallons) - 14\" x 28",
    "url": "https://thecleaningbusiness.com/products/pacific-floorcare-s-28-orbital-floor-scrubber-14x28",
    "type": "product",
    "price": 15252.89,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/pacific--s-28-orbital-floor-scrubber-875425.jpg?v=1782338702",
    "bestFor": [
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus"
    ]
  },
  {
    "id": "machine-pacific-floorcare-32-inch-battery-powered-s-32-auto-scrubber",
    "name": "Pacific Floorcare® 32\" Battery Powered S-32 Auto Scrubber (22 Gallon) w/ Pad Dri",
    "url": "https://thecleaningbusiness.com/products/pacific-floorcare-32-inch-battery-powered-s-32-auto-scrubber",
    "type": "product",
    "price": 15151.36,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/pacific-floorcare-32-inch-battery-powered-s-32-auto-scrubber.jpg?v=1782357949",
    "bestFor": [
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus"
    ]
  },
  {
    "id": "machine-tornado-bd-26-27-rider-auto-scrubber-w-pad-drivers-27-gallons",
    "name": "Tornado® BD 26/27 Rider Auto Scrubber w/ Pad Drivers - 27 Gallons",
    "url": "https://thecleaningbusiness.com/products/tornado-bd-26-27-rider-auto-scrubber-w-pad-drivers-27-gallons",
    "type": "product",
    "price": 14795,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tornado-26-27-ride-on-scrubber.jpg?v=1782359175",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-ipc-eagle-24-in-ride-on-automatic-floor-scrubber-ct80-series",
    "name": "IPC Eagle CT80 Compact Ride on Automatic Floor Scrubber (24\" Scrub Deck) - 21 Ga",
    "url": "https://thecleaningbusiness.com/products/ipc-eagle-24-in-ride-on-automatic-floor-scrubber-ct80-series",
    "type": "product",
    "price": 14692,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-ct80-scrubber-v2.jpg?v=1782338722",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-advance-sc750-st-26-inch-battery-floor-scrubber",
    "name": "Advance® SC750™ ST 26\" Battery Floor Scrubber w/ Pad Holders",
    "url": "https://thecleaningbusiness.com/products/advance-sc750-st-26-inch-battery-floor-scrubber",
    "type": "product",
    "price": 14396,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/advance-sc750-st-scrubber.jpg?v=1782359183",
    "bestFor": [
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus"
    ]
  },
  {
    "id": "machine-pacific-floorcare-28-inch-battery-powered-s-28-floor-scrubber",
    "name": "Pacific Floorcare® 28\" Battery Powered S-28 Floor Scrubber (22 Gallon) w/ Pad Dr",
    "url": "https://thecleaningbusiness.com/products/pacific-floorcare-28-inch-battery-powered-s-28-floor-scrubber",
    "type": "product",
    "price": 14071.74,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/pacific-floorcare-875409-s-28-floor-scrubber.jpg?v=1782359190",
    "bestFor": [
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus"
    ]
  },
  {
    "id": "machine-ipc-eagle-ct71xp-600-rpm-high-speed-28-automatic-floor-polisher-and-scrubber-19-gallons",
    "name": "IPC Eagle CT71XP 600 RPM High Speed 28\" Automatic Floor Polisher & Scrubber w/ P",
    "url": "https://thecleaningbusiness.com/products/ipc-eagle-ct71xp-600-rpm-high-speed-28-automatic-floor-polisher-and-scrubber-19-gallons",
    "type": "product",
    "price": 13603,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ct71xp70-traction-drive-28-inch-floor-scrubber.jpg?v=1782639565",
    "bestFor": [
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus"
    ]
  },
  {
    "id": "machine-viper-as7190to-walk-behind-orbital-automatic-floor-scrubber-w-traction-drive",
    "name": "Viper AS7190TO Walk Behind Orbital Automatic Floor Scrubber (14\" x 28\" Head) w/ ",
    "url": "https://thecleaningbusiness.com/products/viper-as7190to-walk-behind-orbital-automatic-floor-scrubber-w-traction-drive",
    "type": "product",
    "price": 13216,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/viper-as7190to-walk-behind-orbital-scrubber.jpg?v=1782338750",
    "bestFor": [
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus"
    ]
  },
  {
    "id": "machine-nilfisk-sc550-cylindrical-floor-scrubber-li-ion-battery",
    "name": "Nilfisk® SC550 Cylindrical 20\" Floor Scrubber w/ Li-ion Battery - 13 Gallons",
    "url": "https://thecleaningbusiness.com/products/nilfisk-sc550-cylindrical-floor-scrubber-li-ion-battery",
    "type": "product",
    "price": 12516,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/nilfisk-sc550-cylindrical-floor-scrubber-with-li-ion-battery-50000673.webp?v=1782338776",
    "bestFor": [
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus"
    ]
  },
  {
    "id": "machine-40-inch-dust-control-propane-burnisher",
    "name": "Pioneer Eclipse High Speed 40\" Propane Floor Burnisher w/ 18 HP Kawasaki Enigine",
    "url": "https://thecleaningbusiness.com/products/40-inch-dust-control-propane-burnisher",
    "type": "product",
    "price": 12226.92,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/large-area-40-inch-dust-control-burnisher.jpg?v=1782338799",
    "bestFor": [
      "7500_15000",
      "15000_plus",
      "hard_floors"
    ]
  },
  {
    "id": "machine-advance-sc2000-20-inch-compact-ride-on-floor-scrubber",
    "name": "Advance® SC2000™ 20\" Compact Ride-on Floor Scrubber w/ Pad Drivers - 18.5 Gallon",
    "url": "https://thecleaningbusiness.com/products/advance-sc2000-20-inch-compact-ride-on-floor-scrubber",
    "type": "product",
    "price": 12198,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/advance-sc2000-rider-scrubber-right.jpg?v=1782639575",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-advance-adfinity-x20c-cylindrical-battery-floor-scrubber-with-ecoflex",
    "name": "Advance® Adfinity™ X20C Cylindrical 20\" Battery Floor Scrubber w/ EcoFlex™ - 14.",
    "url": "https://thecleaningbusiness.com/products/advance-adfinity-x20c-cylindrical-battery-floor-scrubber-with-ecoflex",
    "type": "product",
    "price": 12067,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/advance-adfinity-x20c-scrubber.jpg?v=1782338817",
    "bestFor": [
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus"
    ]
  },
  {
    "id": "machine-tennant-t581-micro-20-inch-ride-on-floor-scrubber",
    "name": "Tennant® T581 Micro 20\" Ride-On Floor Scrubber w/ Pad Driver - 20 Gallons",
    "url": "https://thecleaningbusiness.com/products/tennant-t581-micro-20-inch-ride-on-floor-scrubber",
    "type": "product",
    "price": 12007,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tennant-t581-micro-20-inch-ride-on-floor-scrubber.jpg?v=1782639585",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-minuteman-max-ride-26-automatic-floor-scrubber",
    "name": "Minuteman® Max Ride 26 Automatic Floor Scrubber (Battery Upgrade Option Availabl",
    "url": "https://thecleaningbusiness.com/products/minuteman-max-ride-26-automatic-floor-scrubber",
    "type": "product",
    "price": 11780.1,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/minuteman-max-ride-26-automatic-floor-scrubber.jpg?v=1782338839",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-advance-sc1500-commercial-20-inch-stand-up-floor-scrubber",
    "name": "Advance® SC1500™ Commercial 20\" Stand-On Floor Scrubber w/ EcoFlex™ & Optional R",
    "url": "https://thecleaningbusiness.com/products/advance-sc1500-commercial-20-inch-stand-up-floor-scrubber",
    "type": "product",
    "price": 11543,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/advance-sc1500-stand-on-rider-floor-scrubber.jpg?v=1782338862",
    "bestFor": [
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus"
    ]
  },
  {
    "id": "machine-clarke-ra40-20d-micro-rider-scrubber",
    "name": "Clarke® RA40™ 20D Rider Floor Scrubber w/ Pad Driver (20\" Scrub Deck) - 18.5 Gal",
    "url": "https://thecleaningbusiness.com/products/clarke-ra40-20d-micro-rider-scrubber",
    "type": "product",
    "price": 11413,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/clarke-ra40-20d-micro-rider-scrubber_1.jpg?v=1782639606",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-ipc-eagle-ct71-traction-drive-automatic-floor-scrubber-24-or-28-inch",
    "name": "IPC Eagle CT71 Traction Drive Automatic Floor Scrubber w/ Pad Drivers (24\" & 28\"",
    "url": "https://thecleaningbusiness.com/products/ipc-eagle-ct71-traction-drive-automatic-floor-scrubber-24-or-28-inch",
    "type": "product",
    "price": 11325,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ct71-bt60-obc-p-145-conf.jpg?v=1782639618",
    "bestFor": [
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus"
    ]
  },
  {
    "id": "machine-minuteman-h26-hospital-floor-scrubber",
    "name": "Minuteman® H26 Compact Automatic Floor Scrubber for Hospitals w/ Pad Drivers - 1",
    "url": "https://thecleaningbusiness.com/products/minuteman-h26-hospital-floor-scrubber",
    "type": "product",
    "price": 11301.78,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/minuteman_h26_lg.jpg?v=1782639629",
    "bestFor": [
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus"
    ]
  },
  {
    "id": "machine-cleanfreak-4-gpm-trailer-mount-pressure-washer-with-tank-and-100-foot-hose",
    "name": "CleanFreak® 4.0 GPM Hot Water Pressure Washing Skid w/ Tank, Reels & Spray Gun (",
    "url": "https://thecleaningbusiness.com/products/cleanfreak-4-gpm-trailer-mount-pressure-washer-with-tank-and-100-foot-hose",
    "type": "product",
    "price": 11178.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/2-reels-on-the-cleanfreak-4-gpm-mountable-pressure-washing-system.jpg?v=1782338887",
    "bestFor": [
      "7500_15000",
      "15000_plus",
      "greasy_floors"
    ]
  },
  {
    "id": "machine-pioneer-eclipse-315asr-30-inch-ride-on-floor-scrubber",
    "name": "Pioneer Eclipse 315ASR 30\" Ride On Floor Scrubber",
    "url": "https://thecleaningbusiness.com/products/pioneer-eclipse-315asr-30-inch-ride-on-floor-scrubber",
    "type": "product",
    "price": 10949.99,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/pioneer-315asr-auto-scrubber.jpg?v=1782338918",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-ipc-eagle-ct51xp-600-rpm-high-speed-28-inch-automatic-floor-polisher-and-scrubber-13-gallo",
    "name": "IPC Eagle CT51XP 600 RPM High Speed 28\" Automatic Floor Polisher & Scrubber w/ P",
    "url": "https://thecleaningbusiness.com/products/ipc-eagle-ct51xp-600-rpm-high-speed-28-inch-automatic-floor-polisher-and-scrubber-13-gallo",
    "type": "product",
    "price": 10795,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/ipc-eagle-ct51-ct71-floor-scrubber-v2.jpg?v=1782639638",
    "bestFor": [
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus"
    ]
  },
  {
    "id": "machine-minuteman-26-inch-self-propelled-battery-floor-scrubber",
    "name": "Minuteman® 26\" Self Propelled Battery Floor Scrubber w/ Pad Drivers",
    "url": "https://thecleaningbusiness.com/products/minuteman-26-inch-self-propelled-battery-floor-scrubber",
    "type": "product",
    "price": 10729.33,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/minuteman_e26_auto_floor_scrubber_lg.jpg?v=1782639649",
    "bestFor": [
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus"
    ]
  },
  {
    "id": "machine-viper-32-inch-auto-scrubber",
    "name": "Viper Fang 32 inch Automatic Floor Scrubber",
    "url": "https://thecleaningbusiness.com/products/viper-32-inch-auto-scrubber",
    "type": "product",
    "price": 10657,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/viper-fang-32-inch-auto-scrubber.jpg?v=1782338942",
    "bestFor": [
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus"
    ]
  },
  {
    "id": "machine-powr-flite-crossover-26-inch-rider-automatic-floor-scrubber-pas26r",
    "name": "Powr-Flite® Crossover 26\" Rider Automatic Floor Scrubber w/ Pad Drivers (#PAS26R",
    "url": "https://thecleaningbusiness.com/products/powr-flite-crossover-26-inch-rider-automatic-floor-scrubber-pas26r",
    "type": "product",
    "price": 10501,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/powr-flite-crossover-26-inch-rider-floor-scrubber-pas26r.jpg?v=1782639656",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-clarke-focus-boost-28-inch-orbital-auto-scrubber-demo",
    "name": "Clarke® Focus® II Boost® 28 inch Orbital Auto Scrubber (Refurbished)",
    "url": "https://thecleaningbusiness.com/products/clarke-focus-boost-28-inch-orbital-auto-scrubber-demo",
    "type": "product",
    "price": 10500,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/image2.ashx_1.jpg?v=1782338971",
    "bestFor": [
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus"
    ]
  },
  {
    "id": "machine-viper-as7690t-walk-behind-30-inch-automatic-floor-scrubber",
    "name": "Viper AS7690T Walk Behind 30\" Automatic Floor Scrubber - 22 Gallon",
    "url": "https://thecleaningbusiness.com/products/viper-as7690t-walk-behind-30-inch-automatic-floor-scrubber",
    "type": "product",
    "price": 10391,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/viper-30-walk-behind-battery-auto-scrubber-as7690-t.jpg?v=1782338996",
    "bestFor": [
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus"
    ]
  },
  {
    "id": "machine-pacific-floorcare-s-24xm-24-inch-battery-powered-floor-scrubber-11-gallon",
    "name": "Pacific Floorcare® S-24XM 24\" Battery Powered Floor Scrubber (11 Gallon) w/ Pad ",
    "url": "https://thecleaningbusiness.com/products/pacific-floorcare-s-24xm-24-inch-battery-powered-floor-scrubber-11-gallon",
    "type": "product",
    "price": 10304.6,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/pacific-s-24-xm-floor-scrubber-24-inch_22e54272-bd23-4e70-9af4-8429ab0601cb.jpg?v=1782639674",
    "bestFor": [
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus"
    ]
  },
  {
    "id": "machine-tennant-t390-self-propelled-28-inch-floor-scrubber",
    "name": "Tennant® T390 Self-Propelled 28\" Walk Behind Automatic Floor Scrubber w/ Pad Dri",
    "url": "https://thecleaningbusiness.com/products/tennant-t390-self-propelled-28-inch-floor-scrubber",
    "type": "product",
    "price": 10292,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/tennant-t390-28-in-scrubber-left.jpg?v=1782639682",
    "bestFor": [
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors",
      "15000_plus"
    ]
  },
  {
    "id": "machine-viper-as530r-micro-rider-floor-scrubber",
    "name": "Viper AS530R™ Micro Rider Floor Scrubber w/ Pad Driver (20\" Scrub Deck) - 19 Gal",
    "url": "https://thecleaningbusiness.com/products/viper-as530r-micro-rider-floor-scrubber",
    "type": "product",
    "price": 10251,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/as530r-ol-rt.jpg?v=1782639692",
    "bestFor": [
      "floor_scrubber",
      "75000_plus",
      "25000_75000",
      "15000_plus",
      "professional",
      "7500_15000",
      "hard_floors"
    ]
  },
  {
    "id": "machine-3040qh-hot-water-gas-pressure-washer-cs-3040qh",
    "name": "3040QH Hot Water Gas Pressure Washer",
    "url": "https://www.thecleaningbusiness.com/products/3040qh-hot-water-gas-pressure-washer-cs-3040qh",
    "type": "product",
    "price": 10198.38,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/Cam-Spray-527100-Pressure-Washer-Sprayer-Foamer-Attachment_sm.jpg?v=1782184793",
    "bestFor": [
      "7500_15000",
      "15000_plus",
      "greasy_floors"
    ]
  },
  {
    "id": "machine-clarke-ca60-24b-boost-automatic-floor-scrubber-14x24-inch-head",
    "name": "Clarke® CA60 24B Boost® Orbital Automatic Floor Scrubber - 14\" x 24\" Head",
    "url": "https://thecleaningbusiness.com/products/clarke-ca60-24b-boost-automatic-floor-scrubber-14x24-inch-head",
    "type": "product",
    "price": 9682,
    "image": "https://cdn.shopify.com/s/files/1/0840/6951/5514/files/clarke-ca60-24b-boost-front-left.jpg?v=1782339022",
    "bestFor": [
      "floor_scrubber",
      "5000_25000",
      "7500_15000",
      "hard_floors"
    ]
  }
];

window.TCB_FINDER_DATA.packages = [
  {
    "id": "package-cleanfreak-17-scrubber",
    "name": "CleanFreak 17\" Scrubber Package",
    "url": "/pages/package-cleanfreak-17-scrubber",
    "facility": "all",
    "bestFor": [
      "floor_scrubber",
      "rubber"
    ]
  },
  {
    "id": "package-mytee-2008cs-extractor",
    "name": "Mytee 2008CS Extractor Package",
    "url": "/pages/package-mytee-2008cs-extractor",
    "facility": "all",
    "bestFor": [
      "carpet_extractor"
    ]
  },
  {
    "id": "package-mytee-220-hose-extractor",
    "name": "Mytee 220 PSI Hose Package",
    "url": "/pages/package-mytee-220-hose-extractor",
    "facility": "all",
    "bestFor": [
      "carpet_extractor"
    ]
  },
  {
    "id": "package-trusted-clean-maximum-contractor",
    "name": "Trusted Clean Maximum Contractor Package",
    "url": "/pages/package-trusted-clean-maximum-contractor",
    "facility": "all",
    "bestFor": []
  },
  {
    "id": "package-clarke-boost-stripping",
    "name": "Clarke Boost Stripping Package",
    "url": "/pages/package-clarke-boost-stripping",
    "facility": "all",
    "bestFor": []
  },
  {
    "id": "package-cleanfreak-performer-20",
    "name": "CleanFreak Performer 20 Scrubber Package",
    "url": "/pages/package-cleanfreak-performer-20",
    "facility": "all",
    "bestFor": [
      "floor_scrubber",
      "rubber"
    ]
  },
  {
    "id": "package-contractor-facility",
    "name": "Contractor Cleaning Package",
    "url": "/pages/package-contractor-facility",
    "facility": "all",
    "bestFor": []
  },
  {
    "id": "package-warehouse-facility",
    "name": "Warehouse Cleaning Package",
    "url": "/pages/package-warehouse-facility",
    "facility": "all",
    "bestFor": []
  },
  {
    "id": "package-school-facility",
    "name": "School & Church Package",
    "url": "/pages/package-school-facility",
    "facility": "all",
    "bestFor": []
  },
  {
    "id": "package-hotel-facility",
    "name": "Hotel & Property Package",
    "url": "/pages/package-hotel-facility",
    "facility": "all",
    "bestFor": []
  },
  {
    "id": "package-healthcare-facility",
    "name": "Healthcare Facility Package",
    "url": "/pages/package-healthcare-facility",
    "facility": "all",
    "bestFor": []
  },
  {
    "id": "package-starter-business",
    "name": "Starter Business Package",
    "url": "/pages/package-starter-business",
    "facility": "all",
    "bestFor": [
      "starter"
    ]
  },
  {
    "id": "package-carpet-extractor-starter",
    "name": "Carpet Extractor Starter Package",
    "url": "/pages/package-carpet-extractor-starter",
    "facility": "all",
    "bestFor": [
      "carpet",
      "carpet_extractor",
      "starter"
    ]
  },
  {
    "id": "package-floor-scrubber-starter",
    "name": "Floor Scrubber Starter Package",
    "url": "/pages/package-floor-scrubber-starter",
    "facility": "all",
    "bestFor": [
      "floor_scrubber",
      "rubber",
      "starter"
    ]
  },
  {
    "id": "school-cleaning-packages",
    "name": "School Cleaning Packages",
    "url": "/pages/school-cleaning-packages",
    "facility": "school",
    "bestFor": [
      "school"
    ]
  },
  {
    "id": "church-cleaning-packages",
    "name": "Church Cleaning Packages",
    "url": "/pages/church-cleaning-packages",
    "facility": "church",
    "bestFor": [
      "church"
    ]
  },
  {
    "id": "gym-cleaning-packages",
    "name": "Gym Cleaning Packages",
    "url": "/pages/gym-cleaning-packages",
    "facility": "gym",
    "bestFor": [
      "gym",
      "gym_floors"
    ]
  },
  {
    "id": "restaurant-cleaning-packages",
    "name": "Restaurant Cleaning Packages",
    "url": "/pages/restaurant-cleaning-packages",
    "facility": "restaurant",
    "bestFor": [
      "restaurant"
    ]
  },
  {
    "id": "warehouse-cleaning-packages",
    "name": "Warehouse Cleaning Packages",
    "url": "/pages/warehouse-cleaning-packages",
    "facility": "warehouse",
    "bestFor": [
      "warehouse"
    ]
  },
  {
    "id": "hotel-cleaning-packages",
    "name": "Hotel & Property Cleaning Packages",
    "url": "/pages/hotel-cleaning-packages",
    "facility": "hotel",
    "bestFor": [
      "hotel"
    ]
  },
  {
    "id": "property-manager-cleaning-packages",
    "name": "Property Manager Cleaning Packages",
    "url": "/pages/property-manager-cleaning-packages",
    "facility": "property_manager",
    "bestFor": [
      "property_manager"
    ]
  },
  {
    "id": "office-cleaning-packages",
    "name": "Office Building Cleaning Packages",
    "url": "/pages/office-cleaning-packages",
    "facility": "office",
    "bestFor": [
      "office"
    ]
  },
  {
    "id": "healthcare-cleaning-packages",
    "name": "Healthcare Cleaning Packages",
    "url": "/pages/healthcare-cleaning-packages",
    "facility": "healthcare",
    "bestFor": [
      "healthcare"
    ]
  },
  {
    "id": "contractor-cleaning-packages",
    "name": "Janitorial Contractor Packages",
    "url": "/pages/contractor-cleaning-packages",
    "facility": "contractor",
    "bestFor": [
      "contractor"
    ]
  },
  {
    "id": "starter-business-packages",
    "name": "Cleaning Business Starter Packages",
    "url": "/pages/starter-business-packages",
    "facility": "startup",
    "bestFor": [
      "startup",
      "starter"
    ]
  },
  {
    "id": "carpet-extractor-packages",
    "name": "Carpet Extractor Packages",
    "url": "/pages/carpet-extractor-packages",
    "facility": "carpet",
    "bestFor": [
      "carpet",
      "carpet_extractor"
    ]
  },
  {
    "id": "floor-scrubber-packages",
    "name": "Floor Scrubber Packages",
    "url": "/pages/floor-scrubber-packages",
    "facility": "floor_scrubber",
    "bestFor": [
      "floor_scrubber",
      "rubber"
    ]
  },
  {
    "id": "package-school-starter-cleaning-package",
    "name": "School Starter Cleaning Package",
    "url": "/pages/package-school-starter-cleaning-package",
    "facility": "school",
    "bestFor": [
      "school",
      "starter",
      "floor_scrubber",
      "restrooms",
      "hallways",
      "rubber",
      "classrooms",
      "cafeteria",
      "gym_floors"
    ]
  },
  {
    "id": "package-classroom-daily-cleaning-package",
    "name": "Classroom Daily Cleaning Package",
    "url": "/pages/package-classroom-daily-cleaning-package",
    "facility": "school",
    "bestFor": [
      "school",
      "starter",
      "floor_scrubber",
      "restrooms",
      "hallways",
      "rubber",
      "classrooms",
      "cafeteria",
      "gym_floors"
    ]
  },
  {
    "id": "package-school-hallway-floor-scrubber-package",
    "name": "School Hallway Floor Scrubber Package",
    "url": "/pages/package-school-hallway-floor-scrubber-package",
    "facility": "school",
    "bestFor": [
      "school",
      "floor_scrubber",
      "restrooms",
      "hallways",
      "rubber",
      "classrooms",
      "cafeteria",
      "gym_floors"
    ]
  },
  {
    "id": "package-school-restroom-cleaning-package",
    "name": "School Restroom Cleaning Package",
    "url": "/pages/package-school-restroom-cleaning-package",
    "facility": "school",
    "bestFor": [
      "school",
      "floor_scrubber",
      "restrooms",
      "greasy_floors",
      "hallways",
      "rubber",
      "classrooms",
      "cafeteria",
      "gym_floors"
    ]
  },
  {
    "id": "package-school-cafeteria-cleaning-package",
    "name": "School Cafeteria Cleaning Package",
    "url": "/pages/package-school-cafeteria-cleaning-package",
    "facility": "school",
    "bestFor": [
      "school",
      "floor_scrubber",
      "restrooms",
      "greasy_floors",
      "hallways",
      "rubber",
      "classrooms",
      "cafeteria",
      "gym_floors"
    ]
  },
  {
    "id": "package-school-gym-floor-cleaning-package",
    "name": "School Gym Floor Cleaning Package",
    "url": "/pages/package-school-gym-floor-cleaning-package",
    "facility": "school",
    "bestFor": [
      "school",
      "professional",
      "floor_scrubber",
      "restrooms",
      "hallways",
      "rubber",
      "classrooms",
      "cafeteria",
      "gym_floors"
    ]
  },
  {
    "id": "package-school-carpet-office-cleaning-package",
    "name": "School Carpet & Office Cleaning Package",
    "url": "/pages/package-school-carpet-office-cleaning-package",
    "facility": "school",
    "bestFor": [
      "school",
      "professional",
      "carpet",
      "carpet_extractor",
      "restrooms",
      "hallways",
      "classrooms",
      "cafeteria",
      "gym_floors"
    ]
  },
  {
    "id": "package-school-full-facility-package",
    "name": "School Full Facility Package",
    "url": "/pages/package-school-full-facility-package",
    "facility": "school",
    "bestFor": [
      "school",
      "professional",
      "floor_scrubber",
      "restrooms",
      "hallways",
      "rubber",
      "classrooms",
      "cafeteria",
      "gym_floors",
      "entire_facility"
    ]
  },
  {
    "id": "package-school-maintenance-parts-refill-package",
    "name": "School Maintenance Parts Refill Package",
    "url": "/pages/package-school-maintenance-parts-refill-package",
    "facility": "school",
    "bestFor": [
      "school",
      "entire_facility",
      "restrooms",
      "hallways",
      "classrooms",
      "cafeteria",
      "gym_floors"
    ]
  },
  {
    "id": "package-school-summer-deep-cleaning-package",
    "name": "School Summer Deep Cleaning Package",
    "url": "/pages/package-school-summer-deep-cleaning-package",
    "facility": "school",
    "bestFor": [
      "school",
      "entire_facility",
      "floor_scrubber",
      "restrooms",
      "hallways",
      "rubber",
      "classrooms",
      "cafeteria",
      "gym_floors"
    ]
  },
  {
    "id": "package-church-starter-cleaning-package",
    "name": "Church Starter Cleaning Package",
    "url": "/pages/package-church-starter-cleaning-package",
    "facility": "church",
    "bestFor": [
      "church",
      "starter",
      "floor_scrubber",
      "restrooms",
      "sanctuary",
      "rubber",
      "classrooms",
      "fellowship"
    ]
  },
  {
    "id": "package-sanctuary-vacuum-floor-care-package",
    "name": "Sanctuary Vacuum & Floor Care Package",
    "url": "/pages/package-sanctuary-vacuum-floor-care-package",
    "facility": "church",
    "bestFor": [
      "church",
      "starter",
      "carpet",
      "carpet_extractor",
      "commercial_vacuum",
      "restrooms",
      "sanctuary",
      "classrooms",
      "fellowship"
    ]
  },
  {
    "id": "package-fellowship-hall-cleaning-package",
    "name": "Fellowship Hall Cleaning Package",
    "url": "/pages/package-fellowship-hall-cleaning-package",
    "facility": "church",
    "bestFor": [
      "church",
      "floor_scrubber",
      "restrooms",
      "sanctuary",
      "rubber",
      "classrooms",
      "fellowship"
    ]
  },
  {
    "id": "package-church-restroom-cleaning-package",
    "name": "Church Restroom Cleaning Package",
    "url": "/pages/package-church-restroom-cleaning-package",
    "facility": "church",
    "bestFor": [
      "church",
      "floor_scrubber",
      "restrooms",
      "sanctuary",
      "rubber",
      "classrooms",
      "fellowship"
    ]
  },
  {
    "id": "package-church-carpet-cleaning-package",
    "name": "Church Carpet Cleaning Package",
    "url": "/pages/package-church-carpet-cleaning-package",
    "facility": "church",
    "bestFor": [
      "church",
      "carpet",
      "carpet_extractor",
      "restrooms",
      "sanctuary",
      "classrooms",
      "fellowship"
    ]
  },
  {
    "id": "package-church-event-cleanup-package",
    "name": "Church Event Cleanup Package",
    "url": "/pages/package-church-event-cleanup-package",
    "facility": "church",
    "bestFor": [
      "church",
      "floor_scrubber",
      "restrooms",
      "sanctuary",
      "rubber",
      "events",
      "classrooms",
      "fellowship"
    ]
  },
  {
    "id": "package-church-volunteer-friendly-cleaning-package",
    "name": "Church Volunteer-Friendly Cleaning Package",
    "url": "/pages/package-church-volunteer-friendly-cleaning-package",
    "facility": "church",
    "bestFor": [
      "church",
      "professional",
      "floor_scrubber",
      "commercial_vacuum",
      "restrooms",
      "sanctuary",
      "rubber",
      "volunteer",
      "classrooms",
      "fellowship"
    ]
  },
  {
    "id": "package-church-full-facility-package",
    "name": "Church Full Facility Package",
    "url": "/pages/package-church-full-facility-package",
    "facility": "church",
    "bestFor": [
      "church",
      "professional",
      "floor_scrubber",
      "commercial_vacuum",
      "restrooms",
      "sanctuary",
      "rubber",
      "classrooms",
      "fellowship",
      "entire_facility"
    ]
  },
  {
    "id": "package-church-maintenance-storage-package",
    "name": "Church Maintenance & Storage Package",
    "url": "/pages/package-church-maintenance-storage-package",
    "facility": "church",
    "bestFor": [
      "church",
      "entire_facility",
      "restrooms",
      "sanctuary",
      "classrooms",
      "fellowship"
    ]
  },
  {
    "id": "package-church-budget-cleaning-package",
    "name": "Church Budget Cleaning Package",
    "url": "/pages/package-church-budget-cleaning-package",
    "facility": "church",
    "bestFor": [
      "church",
      "entire_facility",
      "floor_scrubber",
      "commercial_vacuum",
      "restrooms",
      "sanctuary",
      "rubber",
      "classrooms",
      "fellowship"
    ]
  },
  {
    "id": "package-gym-starter-cleaning-package",
    "name": "Gym Starter Cleaning Package",
    "url": "/pages/package-gym-starter-cleaning-package",
    "facility": "gym",
    "bestFor": [
      "gym",
      "starter",
      "floor_scrubber",
      "restrooms",
      "rubber",
      "locker_room",
      "gym_floors"
    ]
  },
  {
    "id": "package-rubber-floor-cleaning-package",
    "name": "Rubber Floor Cleaning Package",
    "url": "/pages/package-rubber-floor-cleaning-package",
    "facility": "gym",
    "bestFor": [
      "gym",
      "starter",
      "floor_scrubber",
      "restrooms",
      "rubber",
      "locker_room",
      "gym_floors"
    ]
  },
  {
    "id": "package-locker-room-restroom-cleaning-package",
    "name": "Locker Room & Restroom Cleaning Package",
    "url": "/pages/package-locker-room-restroom-cleaning-package",
    "facility": "gym",
    "bestFor": [
      "gym",
      "floor_scrubber",
      "restrooms",
      "rubber",
      "locker_room",
      "gym_floors"
    ]
  },
  {
    "id": "package-weight-room-disinfection-package",
    "name": "Weight Room Disinfection Package",
    "url": "/pages/package-weight-room-disinfection-package",
    "facility": "gym",
    "bestFor": [
      "gym",
      "floor_scrubber",
      "restrooms",
      "rubber",
      "locker_room",
      "gym_floors"
    ]
  },
  {
    "id": "package-cardio-area-cleaning-package",
    "name": "Cardio Area Cleaning Package",
    "url": "/pages/package-cardio-area-cleaning-package",
    "facility": "gym",
    "bestFor": [
      "gym",
      "floor_scrubber",
      "restrooms",
      "rubber",
      "locker_room",
      "gym_floors"
    ]
  },
  {
    "id": "package-gym-odor-control-package",
    "name": "Gym Odor Control Package",
    "url": "/pages/package-gym-odor-control-package",
    "facility": "gym",
    "bestFor": [
      "gym",
      "floor_scrubber",
      "restrooms",
      "rubber",
      "locker_room",
      "odor",
      "gym_floors"
    ]
  },
  {
    "id": "package-gym-floor-scrubber-package",
    "name": "Gym Floor Scrubber Package",
    "url": "/pages/package-gym-floor-scrubber-package",
    "facility": "gym",
    "bestFor": [
      "gym",
      "professional",
      "floor_scrubber",
      "restrooms",
      "rubber",
      "locker_room",
      "gym_floors"
    ]
  },
  {
    "id": "package-gym-full-facility-package",
    "name": "Gym Full Facility Package",
    "url": "/pages/package-gym-full-facility-package",
    "facility": "gym",
    "bestFor": [
      "gym",
      "professional",
      "floor_scrubber",
      "restrooms",
      "rubber",
      "locker_room",
      "gym_floors",
      "entire_facility"
    ]
  },
  {
    "id": "package-gym-microfiber-spray-system-package",
    "name": "Gym Microfiber & Spray System Package",
    "url": "/pages/package-gym-microfiber-spray-system-package",
    "facility": "gym",
    "bestFor": [
      "gym",
      "entire_facility",
      "floor_scrubber",
      "restrooms",
      "rubber",
      "locker_room",
      "gym_floors"
    ]
  },
  {
    "id": "package-gym-maintenance-parts-package",
    "name": "Gym Maintenance Parts Package",
    "url": "/pages/package-gym-maintenance-parts-package",
    "facility": "gym",
    "bestFor": [
      "gym",
      "entire_facility",
      "restrooms",
      "rubber",
      "locker_room",
      "gym_floors"
    ]
  },
  {
    "id": "package-restaurant-starter-cleaning-package",
    "name": "Restaurant Starter Cleaning Package",
    "url": "/pages/package-restaurant-starter-cleaning-package",
    "facility": "restaurant",
    "bestFor": [
      "restaurant",
      "starter",
      "floor_scrubber",
      "restrooms",
      "kitchen",
      "greasy_floors",
      "rubber",
      "dining"
    ]
  },
  {
    "id": "package-commercial-kitchen-degreasing-package",
    "name": "Commercial Kitchen Degreasing Package",
    "url": "/pages/package-commercial-kitchen-degreasing-package",
    "facility": "restaurant",
    "bestFor": [
      "restaurant",
      "starter",
      "floor_scrubber",
      "restrooms",
      "kitchen",
      "greasy_floors",
      "rubber",
      "dining"
    ]
  },
  {
    "id": "package-dining-room-cleaning-package",
    "name": "Dining Room Cleaning Package",
    "url": "/pages/package-dining-room-cleaning-package",
    "facility": "restaurant",
    "bestFor": [
      "restaurant",
      "floor_scrubber",
      "restrooms",
      "kitchen",
      "rubber",
      "dining"
    ]
  },
  {
    "id": "package-restaurant-restroom-cleaning-package",
    "name": "Restaurant Restroom Cleaning Package",
    "url": "/pages/package-restaurant-restroom-cleaning-package",
    "facility": "restaurant",
    "bestFor": [
      "restaurant",
      "floor_scrubber",
      "restrooms",
      "kitchen",
      "rubber",
      "dining"
    ]
  },
  {
    "id": "package-restaurant-floor-scrubber-package",
    "name": "Restaurant Floor Scrubber Package",
    "url": "/pages/package-restaurant-floor-scrubber-package",
    "facility": "restaurant",
    "bestFor": [
      "restaurant",
      "floor_scrubber",
      "restrooms",
      "kitchen",
      "rubber",
      "dining"
    ]
  },
  {
    "id": "package-restaurant-wet-dry-vacuum-package",
    "name": "Restaurant Wet/Dry Vacuum Package",
    "url": "/pages/package-restaurant-wet-dry-vacuum-package",
    "facility": "restaurant",
    "bestFor": [
      "restaurant",
      "commercial_vacuum",
      "restrooms",
      "kitchen",
      "wet_dry",
      "dining"
    ]
  },
  {
    "id": "package-restaurant-closing-shift-cleaning-package",
    "name": "Restaurant Closing Shift Cleaning Package",
    "url": "/pages/package-restaurant-closing-shift-cleaning-package",
    "facility": "restaurant",
    "bestFor": [
      "restaurant",
      "professional",
      "floor_scrubber",
      "commercial_vacuum",
      "restrooms",
      "kitchen",
      "rubber",
      "wet_dry",
      "dining"
    ]
  },
  {
    "id": "package-restaurant-full-facility-package",
    "name": "Restaurant Full Facility Package",
    "url": "/pages/package-restaurant-full-facility-package",
    "facility": "restaurant",
    "bestFor": [
      "restaurant",
      "professional",
      "floor_scrubber",
      "commercial_vacuum",
      "restrooms",
      "kitchen",
      "rubber",
      "wet_dry",
      "dining",
      "entire_facility"
    ]
  },
  {
    "id": "package-restaurant-grease-control-package",
    "name": "Restaurant Grease Control Package",
    "url": "/pages/package-restaurant-grease-control-package",
    "facility": "restaurant",
    "bestFor": [
      "restaurant",
      "entire_facility",
      "floor_scrubber",
      "restrooms",
      "kitchen",
      "greasy_floors",
      "rubber",
      "dining"
    ]
  },
  {
    "id": "package-restaurant-safety-wet-floor-package",
    "name": "Restaurant Safety & Wet Floor Package",
    "url": "/pages/package-restaurant-safety-wet-floor-package",
    "facility": "restaurant",
    "bestFor": [
      "restaurant",
      "entire_facility",
      "floor_scrubber",
      "restrooms",
      "kitchen",
      "rubber",
      "dining"
    ]
  },
  {
    "id": "package-warehouse-starter-cleaning-package",
    "name": "Warehouse Starter Cleaning Package",
    "url": "/pages/package-warehouse-starter-cleaning-package",
    "facility": "warehouse",
    "bestFor": [
      "warehouse",
      "starter",
      "floor_scrubber",
      "restrooms",
      "rubber"
    ]
  },
  {
    "id": "package-concrete-floor-scrubber-package",
    "name": "Concrete Floor Scrubber Package",
    "url": "/pages/package-concrete-floor-scrubber-package",
    "facility": "warehouse",
    "bestFor": [
      "warehouse",
      "starter",
      "floor_scrubber",
      "restrooms",
      "warehouse_concrete",
      "rubber",
      "large"
    ]
  },
  {
    "id": "package-warehouse-dust-debris-package",
    "name": "Warehouse Dust & Debris Package",
    "url": "/pages/package-warehouse-dust-debris-package",
    "facility": "warehouse",
    "bestFor": [
      "warehouse",
      "commercial_vacuum",
      "restrooms",
      "sweeper"
    ]
  },
  {
    "id": "package-loading-dock-cleaning-package",
    "name": "Loading Dock Cleaning Package",
    "url": "/pages/package-loading-dock-cleaning-package",
    "facility": "warehouse",
    "bestFor": [
      "warehouse",
      "floor_scrubber",
      "restrooms",
      "greasy_floors",
      "rubber"
    ]
  },
  {
    "id": "package-warehouse-sweeper-package",
    "name": "Warehouse Sweeper Package",
    "url": "/pages/package-warehouse-sweeper-package",
    "facility": "warehouse",
    "bestFor": [
      "warehouse",
      "floor_scrubber",
      "restrooms",
      "sweeper",
      "rubber",
      "large"
    ]
  },
  {
    "id": "package-warehouse-wet-dry-vacuum-package",
    "name": "Warehouse Wet/Dry Vacuum Package",
    "url": "/pages/package-warehouse-wet-dry-vacuum-package",
    "facility": "warehouse",
    "bestFor": [
      "warehouse",
      "commercial_vacuum",
      "restrooms",
      "wet_dry"
    ]
  },
  {
    "id": "package-warehouse-heavy-duty-floor-care-package",
    "name": "Warehouse Heavy-Duty Floor Care Package",
    "url": "/pages/package-warehouse-heavy-duty-floor-care-package",
    "facility": "warehouse",
    "bestFor": [
      "warehouse",
      "professional",
      "floor_scrubber",
      "restrooms",
      "greasy_floors",
      "rubber"
    ]
  },
  {
    "id": "package-warehouse-full-facility-package",
    "name": "Warehouse Full Facility Package",
    "url": "/pages/package-warehouse-full-facility-package",
    "facility": "warehouse",
    "bestFor": [
      "warehouse",
      "professional",
      "floor_scrubber",
      "restrooms",
      "sweeper",
      "rubber",
      "entire_facility"
    ]
  },
  {
    "id": "package-warehouse-maintenance-parts-package",
    "name": "Warehouse Maintenance Parts Package",
    "url": "/pages/package-warehouse-maintenance-parts-package",
    "facility": "warehouse",
    "bestFor": [
      "warehouse",
      "entire_facility",
      "floor_scrubber",
      "restrooms",
      "rubber"
    ]
  },
  {
    "id": "package-warehouse-safety-spill-response-package",
    "name": "Warehouse Safety & Spill Response Package",
    "url": "/pages/package-warehouse-safety-spill-response-package",
    "facility": "warehouse",
    "bestFor": [
      "warehouse",
      "entire_facility",
      "floor_scrubber",
      "restrooms",
      "rubber"
    ]
  },
  {
    "id": "package-hotel-starter-cleaning-package",
    "name": "Hotel Starter Cleaning Package",
    "url": "/pages/package-hotel-starter-cleaning-package",
    "facility": "hotel",
    "bestFor": [
      "hotel",
      "starter",
      "carpet",
      "carpet_extractor",
      "floor_scrubber",
      "commercial_vacuum",
      "restrooms",
      "hallways",
      "rubber",
      "lobby"
    ]
  },
  {
    "id": "package-hotel-carpet-extractor-package",
    "name": "Hotel Carpet Extractor Package",
    "url": "/pages/package-hotel-carpet-extractor-package",
    "facility": "carpet",
    "bestFor": [
      "carpet",
      "carpet_extractor"
    ]
  },
  {
    "id": "package-hotel-hallway-lobby-package",
    "name": "Hotel Hallway & Lobby Package",
    "url": "/pages/package-hotel-hallway-lobby-package",
    "facility": "hotel",
    "bestFor": [
      "hotel",
      "floor_scrubber",
      "restrooms",
      "hallways",
      "rubber",
      "lobby"
    ]
  },
  {
    "id": "package-guest-room-cleaning-package",
    "name": "Guest Room Cleaning Package",
    "url": "/pages/package-guest-room-cleaning-package",
    "facility": "hotel",
    "bestFor": [
      "hotel",
      "carpet",
      "carpet_extractor",
      "restrooms",
      "hallways",
      "lobby"
    ]
  },
  {
    "id": "package-hotel-restroom-cleaning-package",
    "name": "Hotel Restroom Cleaning Package",
    "url": "/pages/package-hotel-restroom-cleaning-package",
    "facility": "hotel",
    "bestFor": [
      "hotel",
      "floor_scrubber",
      "restrooms",
      "hallways",
      "rubber",
      "lobby"
    ]
  },
  {
    "id": "package-housekeeping-cart-package",
    "name": "Housekeeping Cart Package",
    "url": "/pages/package-housekeeping-cart-package",
    "facility": "hotel",
    "bestFor": [
      "hotel",
      "floor_scrubber",
      "restrooms",
      "hallways",
      "rubber",
      "lobby",
      "guest_rooms"
    ]
  },
  {
    "id": "package-odor-control-package",
    "name": "Odor Control Package",
    "url": "/pages/package-odor-control-package",
    "facility": "hotel",
    "bestFor": [
      "hotel",
      "professional",
      "carpet",
      "carpet_extractor",
      "floor_scrubber",
      "commercial_vacuum",
      "restrooms",
      "hallways",
      "rubber",
      "odor",
      "lobby"
    ]
  },
  {
    "id": "package-hotel-full-facility-package",
    "name": "Hotel Full Facility Package",
    "url": "/pages/package-hotel-full-facility-package",
    "facility": "hotel",
    "bestFor": [
      "hotel",
      "professional",
      "carpet",
      "carpet_extractor",
      "floor_scrubber",
      "commercial_vacuum",
      "restrooms",
      "hallways",
      "rubber",
      "lobby",
      "entire_facility"
    ]
  },
  {
    "id": "package-property-turnover-cleaning-package",
    "name": "Property Turnover Cleaning Package",
    "url": "/pages/package-property-turnover-cleaning-package",
    "facility": "hotel",
    "bestFor": [
      "hotel",
      "entire_facility",
      "carpet",
      "carpet_extractor",
      "floor_scrubber",
      "commercial_vacuum",
      "restrooms",
      "hallways",
      "rubber",
      "turnover",
      "lobby"
    ]
  },
  {
    "id": "package-hotel-maintenance-parts-package",
    "name": "Hotel Maintenance Parts Package",
    "url": "/pages/package-hotel-maintenance-parts-package",
    "facility": "hotel",
    "bestFor": [
      "hotel",
      "entire_facility",
      "restrooms",
      "hallways",
      "lobby"
    ]
  },
  {
    "id": "package-apartment-turnover-cleaning-package",
    "name": "Apartment Turnover Cleaning Package",
    "url": "/pages/package-apartment-turnover-cleaning-package",
    "facility": "property_manager",
    "bestFor": [
      "property_manager",
      "starter",
      "carpet_extractor",
      "floor_scrubber",
      "commercial_vacuum",
      "hallways",
      "rubber",
      "turnover"
    ]
  },
  {
    "id": "package-property-common-area-cleaning-package",
    "name": "Property Common Area Cleaning Package",
    "url": "/pages/package-property-common-area-cleaning-package",
    "facility": "property_manager",
    "bestFor": [
      "property_manager",
      "starter",
      "carpet_extractor",
      "floor_scrubber",
      "commercial_vacuum",
      "hallways",
      "rubber"
    ]
  },
  {
    "id": "package-leasing-office-cleaning-package",
    "name": "Leasing Office Cleaning Package",
    "url": "/pages/package-leasing-office-cleaning-package",
    "facility": "property_manager",
    "bestFor": [
      "property_manager",
      "carpet_extractor",
      "floor_scrubber",
      "commercial_vacuum",
      "hallways",
      "rubber"
    ]
  },
  {
    "id": "package-property-carpet-cleaning-package",
    "name": "Property Carpet Cleaning Package",
    "url": "/pages/package-property-carpet-cleaning-package",
    "facility": "property_manager",
    "bestFor": [
      "property_manager",
      "carpet",
      "carpet_extractor",
      "hallways"
    ]
  },
  {
    "id": "package-property-hallway-floor-care-package",
    "name": "Property Hallway Floor Care Package",
    "url": "/pages/package-property-hallway-floor-care-package",
    "facility": "property_manager",
    "bestFor": [
      "property_manager",
      "carpet",
      "carpet_extractor",
      "hallways"
    ]
  },
  {
    "id": "package-move-in-move-out-cleaning-package",
    "name": "Move-In / Move-Out Cleaning Package",
    "url": "/pages/package-move-in-move-out-cleaning-package",
    "facility": "property_manager",
    "bestFor": [
      "property_manager",
      "carpet_extractor",
      "floor_scrubber",
      "commercial_vacuum",
      "hallways",
      "rubber"
    ]
  },
  {
    "id": "package-property-restroom-cleaning-package",
    "name": "Property Restroom Cleaning Package",
    "url": "/pages/package-property-restroom-cleaning-package",
    "facility": "property_manager",
    "bestFor": [
      "property_manager",
      "professional",
      "commercial_vacuum",
      "restrooms",
      "hallways",
      "wet_dry"
    ]
  },
  {
    "id": "package-multi-building-cleaning-package",
    "name": "Multi-Building Cleaning Package",
    "url": "/pages/package-multi-building-cleaning-package",
    "facility": "property_manager",
    "bestFor": [
      "property_manager",
      "professional",
      "carpet_extractor",
      "floor_scrubber",
      "commercial_vacuum",
      "hallways",
      "rubber"
    ]
  },
  {
    "id": "package-property-maintenance-parts-package",
    "name": "Property Maintenance Parts Package",
    "url": "/pages/package-property-maintenance-parts-package",
    "facility": "property_manager",
    "bestFor": [
      "property_manager",
      "entire_facility",
      "hallways"
    ]
  },
  {
    "id": "package-full-property-manager-package",
    "name": "Full Property Manager Package",
    "url": "/pages/package-full-property-manager-package",
    "facility": "property_manager",
    "bestFor": [
      "property_manager",
      "entire_facility",
      "carpet_extractor",
      "floor_scrubber",
      "commercial_vacuum",
      "hallways",
      "rubber"
    ]
  },
  {
    "id": "package-office-starter-cleaning-package",
    "name": "Office Starter Cleaning Package",
    "url": "/pages/package-office-starter-cleaning-package",
    "facility": "office",
    "bestFor": [
      "office",
      "starter",
      "commercial_vacuum",
      "restrooms",
      "lobby"
    ]
  },
  {
    "id": "package-office-vacuum-package",
    "name": "Office Vacuum Package",
    "url": "/pages/package-office-vacuum-package",
    "facility": "office",
    "bestFor": [
      "office",
      "starter",
      "commercial_vacuum",
      "restrooms",
      "lobby"
    ]
  },
  {
    "id": "package-office-restroom-cleaning-package",
    "name": "Office Restroom Cleaning Package",
    "url": "/pages/package-office-restroom-cleaning-package",
    "facility": "office",
    "bestFor": [
      "office",
      "floor_scrubber",
      "restrooms",
      "rubber",
      "lobby"
    ]
  },
  {
    "id": "package-office-lobby-floor-care-package",
    "name": "Office Lobby Floor Care Package",
    "url": "/pages/package-office-lobby-floor-care-package",
    "facility": "office",
    "bestFor": [
      "office",
      "floor_scrubber",
      "restrooms",
      "rubber",
      "lobby"
    ]
  },
  {
    "id": "package-office-carpet-cleaning-package",
    "name": "Office Carpet Cleaning Package",
    "url": "/pages/package-office-carpet-cleaning-package",
    "facility": "office",
    "bestFor": [
      "office",
      "carpet",
      "carpet_extractor",
      "restrooms",
      "lobby"
    ]
  },
  {
    "id": "package-office-trash-touchpoint-package",
    "name": "Office Trash & Touchpoint Package",
    "url": "/pages/package-office-trash-touchpoint-package",
    "facility": "office",
    "bestFor": [
      "office",
      "floor_scrubber",
      "restrooms",
      "rubber",
      "lobby"
    ]
  },
  {
    "id": "package-office-hard-floor-scrubber-package",
    "name": "Office Hard Floor Scrubber Package",
    "url": "/pages/package-office-hard-floor-scrubber-package",
    "facility": "office",
    "bestFor": [
      "office",
      "professional",
      "floor_scrubber",
      "restrooms",
      "rubber",
      "hard_floors",
      "lobby"
    ]
  },
  {
    "id": "package-office-full-facility-package",
    "name": "Office Full Facility Package",
    "url": "/pages/package-office-full-facility-package",
    "facility": "office",
    "bestFor": [
      "office",
      "professional",
      "carpet",
      "carpet_extractor",
      "floor_scrubber",
      "commercial_vacuum",
      "restrooms",
      "rubber",
      "lobby",
      "entire_facility"
    ]
  },
  {
    "id": "package-office-maintenance-parts-package",
    "name": "Office Maintenance Parts Package",
    "url": "/pages/package-office-maintenance-parts-package",
    "facility": "office",
    "bestFor": [
      "office",
      "entire_facility",
      "restrooms",
      "lobby"
    ]
  },
  {
    "id": "package-corporate-janitorial-package",
    "name": "Corporate Janitorial Package",
    "url": "/pages/package-corporate-janitorial-package",
    "facility": "office",
    "bestFor": [
      "office",
      "entire_facility",
      "carpet",
      "carpet_extractor",
      "floor_scrubber",
      "commercial_vacuum",
      "restrooms",
      "rubber",
      "lobby"
    ]
  },
  {
    "id": "package-healthcare-starter-cleaning-package",
    "name": "Healthcare Starter Cleaning Package",
    "url": "/pages/package-healthcare-starter-cleaning-package",
    "facility": "healthcare",
    "bestFor": [
      "healthcare",
      "starter",
      "carpet",
      "carpet_extractor",
      "restrooms"
    ]
  },
  {
    "id": "package-clinic-cleaning-package",
    "name": "Clinic Cleaning Package",
    "url": "/pages/package-clinic-cleaning-package",
    "facility": "healthcare",
    "bestFor": [
      "healthcare",
      "starter",
      "floor_scrubber",
      "commercial_vacuum",
      "restrooms",
      "rubber"
    ]
  },
  {
    "id": "package-patient-area-cleaning-package",
    "name": "Patient Area Cleaning Package",
    "url": "/pages/package-patient-area-cleaning-package",
    "facility": "healthcare",
    "bestFor": [
      "healthcare",
      "floor_scrubber",
      "restrooms",
      "rubber"
    ]
  },
  {
    "id": "package-waiting-room-cleaning-package",
    "name": "Waiting Room Cleaning Package",
    "url": "/pages/package-waiting-room-cleaning-package",
    "facility": "healthcare",
    "bestFor": [
      "healthcare",
      "carpet",
      "carpet_extractor",
      "restrooms"
    ]
  },
  {
    "id": "package-healthcare-restroom-cleaning-package",
    "name": "Healthcare Restroom Cleaning Package",
    "url": "/pages/package-healthcare-restroom-cleaning-package",
    "facility": "healthcare",
    "bestFor": [
      "healthcare",
      "floor_scrubber",
      "restrooms",
      "rubber"
    ]
  },
  {
    "id": "package-healthcare-floor-care-package",
    "name": "Healthcare Floor Care Package",
    "url": "/pages/package-healthcare-floor-care-package",
    "facility": "healthcare",
    "bestFor": [
      "healthcare",
      "floor_scrubber",
      "restrooms",
      "rubber"
    ]
  },
  {
    "id": "package-healthcare-microfiber-system-package",
    "name": "Healthcare Microfiber System Package",
    "url": "/pages/package-healthcare-microfiber-system-package",
    "facility": "healthcare",
    "bestFor": [
      "healthcare",
      "professional",
      "floor_scrubber",
      "commercial_vacuum",
      "restrooms",
      "rubber"
    ]
  },
  {
    "id": "package-healthcare-full-facility-package",
    "name": "Healthcare Full Facility Package",
    "url": "/pages/package-healthcare-full-facility-package",
    "facility": "healthcare",
    "bestFor": [
      "healthcare",
      "professional",
      "floor_scrubber",
      "commercial_vacuum",
      "restrooms",
      "rubber",
      "entire_facility"
    ]
  },
  {
    "id": "package-healthcare-safety-ppe-package",
    "name": "Healthcare Safety & PPE Package",
    "url": "/pages/package-healthcare-safety-ppe-package",
    "facility": "healthcare",
    "bestFor": [
      "healthcare",
      "entire_facility",
      "floor_scrubber",
      "commercial_vacuum",
      "restrooms",
      "rubber"
    ]
  },
  {
    "id": "package-healthcare-maintenance-parts-package",
    "name": "Healthcare Maintenance Parts Package",
    "url": "/pages/package-healthcare-maintenance-parts-package",
    "facility": "healthcare",
    "bestFor": [
      "healthcare",
      "entire_facility",
      "floor_scrubber",
      "restrooms",
      "rubber"
    ]
  },
  {
    "id": "package-contractor-starter-package",
    "name": "Contractor Starter Package",
    "url": "/pages/package-contractor-starter-package",
    "facility": "contractor",
    "bestFor": [
      "contractor",
      "starter",
      "floor_scrubber",
      "rubber",
      "gym_floors",
      "routes"
    ]
  },
  {
    "id": "package-contractor-office-route-package",
    "name": "Contractor Office Route Package",
    "url": "/pages/package-contractor-office-route-package",
    "facility": "contractor",
    "bestFor": [
      "contractor",
      "starter",
      "floor_scrubber",
      "rubber",
      "gym_floors",
      "routes"
    ]
  },
  {
    "id": "package-contractor-school-church-route-package",
    "name": "Contractor School & Church Route Package",
    "url": "/pages/package-contractor-school-church-route-package",
    "facility": "contractor",
    "bestFor": [
      "contractor",
      "carpet",
      "carpet_extractor",
      "gym_floors",
      "routes"
    ]
  },
  {
    "id": "package-contractor-restaurant-route-package",
    "name": "Contractor Restaurant Route Package",
    "url": "/pages/package-contractor-restaurant-route-package",
    "facility": "contractor",
    "bestFor": [
      "contractor",
      "floor_scrubber",
      "rubber",
      "gym_floors",
      "routes"
    ]
  },
  {
    "id": "package-contractor-carpet-cleaning-package",
    "name": "Contractor Carpet Cleaning Package",
    "url": "/pages/package-contractor-carpet-cleaning-package",
    "facility": "contractor",
    "bestFor": [
      "contractor",
      "carpet",
      "carpet_extractor",
      "routes"
    ]
  },
  {
    "id": "package-contractor-floor-scrubber-package",
    "name": "Contractor Floor Scrubber Package",
    "url": "/pages/package-contractor-floor-scrubber-package",
    "facility": "contractor",
    "bestFor": [
      "contractor",
      "professional",
      "floor_scrubber",
      "rubber",
      "gym_floors",
      "routes"
    ]
  },
  {
    "id": "package-contractor-multi-surface-package",
    "name": "Contractor Multi-Surface Package",
    "url": "/pages/package-contractor-multi-surface-package",
    "facility": "contractor",
    "bestFor": [
      "contractor",
      "professional",
      "carpet_extractor",
      "floor_scrubber",
      "commercial_vacuum",
      "rubber",
      "gym_floors",
      "routes"
    ]
  },
  {
    "id": "package-contractor-full-route-package",
    "name": "Contractor Full Route Package",
    "url": "/pages/package-contractor-full-route-package",
    "facility": "contractor",
    "bestFor": [
      "contractor",
      "professional",
      "gym_floors",
      "routes"
    ]
  },
  {
    "id": "package-contractor-replacement-parts-package",
    "name": "Contractor Replacement Parts Package",
    "url": "/pages/package-contractor-replacement-parts-package",
    "facility": "contractor",
    "bestFor": [
      "contractor",
      "entire_facility",
      "floor_scrubber",
      "rubber",
      "gym_floors",
      "routes"
    ]
  },
  {
    "id": "package-contractor-van-ready-equipment-package",
    "name": "Contractor Van-Ready Equipment Package",
    "url": "/pages/package-contractor-van-ready-equipment-package",
    "facility": "contractor",
    "bestFor": [
      "contractor",
      "entire_facility",
      "floor_scrubber",
      "rubber",
      "gym_floors",
      "routes"
    ]
  },
  {
    "id": "package-solo-cleaner-starter-package",
    "name": "Solo Cleaner Starter Package",
    "url": "/pages/package-solo-cleaner-starter-package",
    "facility": "startup",
    "bestFor": [
      "startup",
      "starter",
      "commercial_vacuum",
      "restrooms",
      "solo",
      "first_account"
    ]
  },
  {
    "id": "package-first-commercial-account-package",
    "name": "First Commercial Account Package",
    "url": "/pages/package-first-commercial-account-package",
    "facility": "startup",
    "bestFor": [
      "startup",
      "starter",
      "commercial_vacuum",
      "restrooms",
      "first_account"
    ]
  },
  {
    "id": "package-office-cleaning-startup-package",
    "name": "Office Cleaning Startup Package",
    "url": "/pages/package-office-cleaning-startup-package",
    "facility": "startup",
    "bestFor": [
      "startup",
      "commercial_vacuum",
      "restrooms",
      "first_account",
      "starter"
    ]
  },
  {
    "id": "package-floor-care-startup-package",
    "name": "Floor Care Startup Package",
    "url": "/pages/package-floor-care-startup-package",
    "facility": "startup",
    "bestFor": [
      "startup",
      "floor_scrubber",
      "restrooms",
      "rubber",
      "first_account",
      "starter"
    ]
  },
  {
    "id": "package-carpet-cleaning-startup-package",
    "name": "Carpet Cleaning Startup Package",
    "url": "/pages/package-carpet-cleaning-startup-package",
    "facility": "startup",
    "bestFor": [
      "startup",
      "carpet",
      "carpet_extractor",
      "restrooms",
      "first_account",
      "starter"
    ]
  },
  {
    "id": "package-janitorial-cart-startup-package",
    "name": "Janitorial Cart Startup Package",
    "url": "/pages/package-janitorial-cart-startup-package",
    "facility": "startup",
    "bestFor": [
      "startup",
      "professional",
      "restrooms",
      "routes",
      "first_account",
      "starter"
    ]
  },
  {
    "id": "package-budget-startup-package",
    "name": "Budget Startup Package",
    "url": "/pages/package-budget-startup-package",
    "facility": "startup",
    "bestFor": [
      "startup",
      "professional",
      "commercial_vacuum",
      "restrooms",
      "first_account",
      "starter"
    ]
  },
  {
    "id": "package-professional-startup-package",
    "name": "Professional Startup Package",
    "url": "/pages/package-professional-startup-package",
    "facility": "startup",
    "bestFor": [
      "startup",
      "professional",
      "commercial_vacuum",
      "restrooms",
      "first_account",
      "starter"
    ]
  },
  {
    "id": "package-contractor-growth-package",
    "name": "Contractor Growth Package",
    "url": "/pages/package-contractor-growth-package",
    "facility": "startup",
    "bestFor": [
      "startup",
      "entire_facility",
      "commercial_vacuum",
      "restrooms",
      "first_account",
      "starter"
    ]
  },
  {
    "id": "package-complete-cleaning-business-launch-package",
    "name": "Complete Cleaning Business Launch Package",
    "url": "/pages/package-complete-cleaning-business-launch-package",
    "facility": "startup",
    "bestFor": [
      "startup",
      "entire_facility",
      "commercial_vacuum",
      "restrooms",
      "first_account",
      "starter"
    ]
  },
  {
    "id": "package-carpet-extractor-starter-package",
    "name": "Carpet Extractor Starter Package",
    "url": "/pages/package-carpet-extractor-starter-package",
    "facility": "carpet",
    "bestFor": [
      "carpet",
      "starter",
      "carpet_extractor"
    ]
  },
  {
    "id": "package-office-carpet-extractor-package",
    "name": "Office Carpet Extractor Package",
    "url": "/pages/package-office-carpet-extractor-package",
    "facility": "carpet",
    "bestFor": [
      "carpet",
      "starter",
      "carpet_extractor"
    ]
  },
  {
    "id": "package-church-carpet-extractor-package",
    "name": "Church Carpet Extractor Package",
    "url": "/pages/package-church-carpet-extractor-package",
    "facility": "carpet",
    "bestFor": [
      "carpet",
      "carpet_extractor"
    ]
  },
  {
    "id": "package-property-manager-carpet-package",
    "name": "Property Manager Carpet Package",
    "url": "/pages/package-property-manager-carpet-package",
    "facility": "carpet",
    "bestFor": [
      "carpet",
      "carpet_extractor"
    ]
  },
  {
    "id": "package-auto-detailing-extractor-package",
    "name": "Auto Detailing Extractor Package",
    "url": "/pages/package-auto-detailing-extractor-package",
    "facility": "carpet",
    "bestFor": [
      "carpet",
      "professional",
      "carpet_extractor"
    ]
  },
  {
    "id": "package-high-psi-extractor-package",
    "name": "High-PSI Extractor Package",
    "url": "/pages/package-high-psi-extractor-package",
    "facility": "carpet",
    "bestFor": [
      "carpet",
      "professional",
      "carpet_extractor"
    ]
  },
  {
    "id": "package-heated-extractor-package",
    "name": "Heated Extractor Package",
    "url": "/pages/package-heated-extractor-package",
    "facility": "carpet",
    "bestFor": [
      "carpet",
      "professional",
      "carpet_extractor"
    ]
  },
  {
    "id": "package-extractor-hose-wand-package",
    "name": "Extractor Hose & Wand Package",
    "url": "/pages/package-extractor-hose-wand-package",
    "facility": "carpet",
    "bestFor": [
      "carpet",
      "entire_facility",
      "carpet_extractor"
    ]
  },
  {
    "id": "package-extractor-maintenance-parts-package",
    "name": "Extractor Maintenance Parts Package",
    "url": "/pages/package-extractor-maintenance-parts-package",
    "facility": "carpet",
    "bestFor": [
      "carpet",
      "entire_facility",
      "carpet_extractor"
    ]
  },
  {
    "id": "package-floor-scrubber-starter-package",
    "name": "Floor Scrubber Starter Package",
    "url": "/pages/package-floor-scrubber-starter-package",
    "facility": "floor_scrubber",
    "bestFor": [
      "floor_scrubber",
      "starter",
      "rubber",
      "hard_floors",
      "gym_floors"
    ]
  },
  {
    "id": "package-small-facility-scrubber-package",
    "name": "Small Facility Scrubber Package",
    "url": "/pages/package-small-facility-scrubber-package",
    "facility": "floor_scrubber",
    "bestFor": [
      "floor_scrubber",
      "starter",
      "rubber",
      "hard_floors",
      "gym_floors"
    ]
  },
  {
    "id": "package-medium-facility-scrubber-package",
    "name": "Medium Facility Scrubber Package",
    "url": "/pages/package-medium-facility-scrubber-package",
    "facility": "floor_scrubber",
    "bestFor": [
      "floor_scrubber",
      "rubber",
      "hard_floors",
      "gym_floors"
    ]
  },
  {
    "id": "package-large-facility-scrubber-package",
    "name": "Large Facility Scrubber Package",
    "url": "/pages/package-large-facility-scrubber-package",
    "facility": "floor_scrubber",
    "bestFor": [
      "floor_scrubber",
      "rubber",
      "hard_floors",
      "gym_floors",
      "large"
    ]
  },
  {
    "id": "package-warehouse-scrubber-package",
    "name": "Warehouse Scrubber Package",
    "url": "/pages/package-warehouse-scrubber-package",
    "facility": "floor_scrubber",
    "bestFor": [
      "floor_scrubber",
      "rubber",
      "hard_floors",
      "gym_floors"
    ]
  },
  {
    "id": "package-school-scrubber-package",
    "name": "School Scrubber Package",
    "url": "/pages/package-school-scrubber-package",
    "facility": "floor_scrubber",
    "bestFor": [
      "floor_scrubber",
      "professional",
      "rubber",
      "hard_floors",
      "gym_floors"
    ]
  },
  {
    "id": "package-restaurant-scrubber-package",
    "name": "Restaurant Scrubber Package",
    "url": "/pages/package-restaurant-scrubber-package",
    "facility": "floor_scrubber",
    "bestFor": [
      "floor_scrubber",
      "professional",
      "rubber",
      "hard_floors",
      "gym_floors"
    ]
  },
  {
    "id": "package-gym-scrubber-package",
    "name": "Gym Scrubber Package",
    "url": "/pages/package-gym-scrubber-package",
    "facility": "floor_scrubber",
    "bestFor": [
      "floor_scrubber",
      "professional",
      "rubber",
      "hard_floors",
      "gym_floors"
    ]
  },
  {
    "id": "package-scrubber-pads-chemicals-package",
    "name": "Scrubber Pads & Chemicals Package",
    "url": "/pages/package-scrubber-pads-chemicals-package",
    "facility": "floor_scrubber",
    "bestFor": [
      "floor_scrubber",
      "entire_facility",
      "rubber",
      "hard_floors",
      "gym_floors"
    ]
  },
  {
    "id": "package-scrubber-maintenance-parts-package",
    "name": "Scrubber Maintenance Parts Package",
    "url": "/pages/package-scrubber-maintenance-parts-package",
    "facility": "floor_scrubber",
    "bestFor": [
      "floor_scrubber",
      "entire_facility",
      "rubber",
      "hard_floors",
      "gym_floors"
    ]
  }
];

window.TCB_FINDER_DATA.productDescriptions = {
  "walk-behind-floor-scrubbers": "Best for routine hard-floor cleaning in offices, schools, churches, restaurants, gyms, and medium facilities.",
  "ride-on-floor-scrubbers": "Best for large facilities, long cleaning routes, warehouses, schools, and high-square-footage spaces.",
  "floor-scrubbers": "Compare commercial scrubbers for daily hard-floor cleaning, wet recovery, and labor savings.",
  "sweepers": "Best for dust, debris, warehouse aisles, loading docks, and industrial floor pickup.",
  "wet-dry-vacuums": "Best for wet spills, dry debris, restrooms, kitchens, warehouses, and versatile facility cleanup.",
  "commercial-vacuums": "Best for daily janitorial routes, carpet pickup, office cleaning, schools, hotels, and churches.",
  "carpet-extractors": "Best for carpet cleaning, upholstery cleaning, spot removal, hotels, churches, and property turnover.",
  "floor-buffers": "Best for floor maintenance, scrubbing, stripping support, and polishing prep.",
  "burnishers": "Best for maintaining a high-gloss floor appearance in commercial facilities.",
  "industrial-cleaning-equipment": "Best for large facilities, heavy-duty cleanup, concrete floors, and industrial environments.",
  "parts": "Find pads, brushes, filters, bags, hoses, wands, squeegee blades, batteries, chargers, and maintenance parts.",
  "chemicals": "Shop floor cleaners, degreasers, restroom cleaners, carpet chemicals, disinfectant options, and odor control.",
  "machine-tennant-t20-industrial-ride-on-floor-scrubber-80-gallon": "Tennant® T20 Industrial Ride-On Floor Scrubber w/ ES® Extended Scrub & ec-H2O™ T — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-tennant-t16-automatic-floor-scrubber": "Tennant® T16 36\" Ride-On Automatic Floor Scrubber w/ ec-H2O™ Technology (Disk Sc — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-outdoor-gas-powered-ride-on-sweeper": "IPC Eagle Genius 58\" Outdoor Gas Powered Ride On Sweeper — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-battery-operated-ride-on-airport-sweeper": "IPC Eagle 1404 Battery Operated Ride On Vacuum Sweeper - 58\" Sweeping Path — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-advancer-sw4000tm-rider-sweeper": "Advance® SW4000™ Rider Sweeper - 49\" Sweeping Path — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-26-34-tvl-850-t-compact-ride-on-adjustable-auto-scrubber-lithium-phosphate-32-ga-4": "26\" - 34\" TVL 850/T Compact Ride-On Adjustable Auto Scrubber - Lithium Phosphate — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-26-34-tvl-850-t-compact-ride-on-adjustable-auto-scrubber-lithium-phosphate-32-ga-3": "26\" - 34\" TVL 850/T Compact Ride-On Adjustable Auto Scrubber - Lithium Phosphate — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-tennant-r14-rider-self-contained-carpet-cleaning-extractor": "Tennant® R14 Rider Self-Contained Carpet Cleaning Extractor (32 Gallons) - 28\" H — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-26-34-tvl-850-t-compact-ride-on-adjustable-auto-scrubber-lithium-phosphate-32-ga-2": "26\" - 34\" TVL 850/T Compact Ride-On Adjustable Auto Scrubber - Lithium Phosphate — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-tennant-t7-ride-on-automatic-floor-scrubber": "Tennant® T7 Ride-On Automatic Floor Scrubber w/ Conventional & ec-H2O NanoClean® — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-clarke-focus-ii-34-disc-rider-autoscrubber-clk-56114031": "Clarke Focus II 34\" Disc Rider Autoscrubber — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-advance-sc4000-ride-on-floor-scrubber": "Advance® SC4000® Ride-On Floor Scrubber w/ REV Technology (Battery, EcoFlex™ & H — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-26-34-tvl-850-t-compact-ride-on-adjustable-auto-scrubber-lithium-phosphate-32-gal-tvl-85": "26\" - 34\" TVL 850/T Compact Ride-On Adjustable Auto Scrubber - Lithium Phosphate — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-advance-advenger-ride-on-floor-scrubber-with-rev-technology": "28\" Advance® Advenger® Ride-On Floor Scrubber w/ REV Technology — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-focus-ii-28-boost-rider-autoscrubber-clk-56114020": "Focus II 28\" BOOST Rider Autoscrubber — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-ipc-eagle-1280-battery-power-rider-sweeper": "IPC Eagle 1280 Battery Powered Rider Vacuum Sweeper - 48\" Sweeping Path — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-36-inch-automatic-ride-on-scrubber": "IPC Eagle CT160 Industrial Automatic Ride On Floor Scrubber (36\" Scrub Deck) - 3 — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-clarke-focus-ii-28-disc-rider-autoscrubber-clk-56114012": "Clarke Focus II 28\" Disc Rider Autoscrubber — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-clarke-focus-ii-boost-automatic-ride-on-floor-scrubber": "Clarke® Focus® II BOOST® Automatic Ride on Floor Scrubber — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-tennant-t600-self-propelled-walk-behind-floor-scrubber": "Tennant® T600 Self-Propelled Walk Behind Automatic Floor Scrubber w/ Pad Drivers — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-pacific-floorcare-rs28-rider-scrubber-with-deck-option": "Pacific Floorcare® RS28 Ride On Automatic Floor Scrubber (28\" Disc or 14\" x 28\"  — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-advance-terra-4300b-compact-rider-sweeper": "Advance Terra® 4300B Compact Rider Sweeper - 46\" Sweeping Path — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-scrubmaster-b120-ride-on-floor-scrubber-financing-available-33-cylindrical-sm3332cqp-284": "Scrubmaster B120 Ride On Floor Scrubber | Financing Available - 33\" Cylindrical  — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-scrubmaster-b120-ride-on-floor-scrubber-financing-available-28-cylindrical-sm2832cqp-284": "Scrubmaster B120 Ride On Floor Scrubber | Financing Available - 28\" Cylindrical  — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-green-cleaning-rider-scrubber": "IPC Eagle CT110 ECS Low Moisture Rider Floor Scrubber (32\" Scrub Deck) - 29 Gall — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-scrubmaster-b120-ride-on-floor-scrubber-financing-available-35-disc-sm3532dqp-28406": "Scrubmaster B120 Ride On Floor Scrubber | Financing Available - 35\" Disc (SM3532 — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-torando-bd-33-30-rider-auto-scrubber-w-pad-drivers": "Torando® BD 33/30 Rider Auto Scrubber w/ Pad Drivers — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-kleen-sweep-47r-ride-on-floor-sweeper-large-area-vacuum-financing-available-base-unit-wi": "Kleen Sweep 47R Ride On Floor Sweeper - Large Area Vacuum | Financing Available  — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-focus-ii-28-boost-microrider-autoscrubber-clk-56382630": "Focus II 28\" BOOST MicroRider Autoscrubber — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-scrubmaster-b120-ride-on-floor-scrubber-financing-available-30-disc-sm3032dqp-28405": "Scrubmaster B120 Ride On Floor Scrubber | Financing Available - 30\" Disc (SM3032 — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-pioneer-eclipse-28-inch-350bu-battery-floor-burnisher": "Pioneer Eclipse 28\" 350BU High Speed Battery Floor Burnisher - 2,000 RPM — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-focus-ii-26-disc-microrider-autoscrubber-clk-56382626": "Focus II 26\" Disc MicroRider Autoscrubber — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-clarke-focus-ii-microrider-auto-scrubber": "Clarke® Focus® II MicroRider™ Auto Floor Scrubber (26\" or 14\" x 28\" Deck Options — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-advance-adgressor-3220d-industrial-32-inch-ride-on-floor-scrubber": "Advance® Adgressor® 3220D Industrial 32\" Ride on Floor Scrubber - 42 Gallon — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-nilfisk-sw3000-li-ion-ride-on-industrial-floor-sweeper": "Nilfisk® SW3000™ Ride-On Industrial Floor Sweeper w/ Li-Ion Batteries - 53\" Swee — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-clarke-clean-track-l24-battery-powered-self-contained-carpet-extractor": "Clarke® Clean Track® L24 Battery Powered Self-Contained Carpet Extractor — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-large-ride-on-automatic-floor-scrubber": "IPC Eagle CT110 Compact Ride-On Automatic Floor Scrubber (32\" Scrub Deck) - 29 G — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-battery-powered-rider-warehouse-sweeper": "IPC Eagle 1050 Battery Powered Rider Warehouse Vacuum Sweeper - 42\" Sweeping Pat — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-aquaplus-axp-battery-powered-self-contained-carpet-extractor-by-advance": "Advance® AquaPLUS™ AXP™ Battery Powered Self-Contained Carpet Extractor — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-viper-as850r-312-rider-auto-scrubber-32-cleaning-path-vp-as850r-312": "Viper AS850R-312 Rider Auto Scrubber - 32\" Cleaning Path — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-advance-sc800-st-34-inch-battery-floor-scrubber": "Advance® SC800™ ST 34\" Battery Powered Floor Scrubber w/ Pad Holders — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-viper-as850r-242-rider-auto-scrubber-32-cleaning-path-vp-as850r-242": "Viper AS850R-242 Rider Auto Scrubber - 32\" Cleaning Path — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-viper-as850r-32-inch-rider-automatic-floor-scrubber": "Viper AS850R 32\" Rider Automatic Floor Scrubber - 32 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-viper-as710r-ride-on-auto-floor-scrubber-28-cleaning-path-vp-as710r": "Viper AS710R Ride On Auto Floor Scrubber - 28\" Cleaning Path — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-viper-ros1300-ride-on-sweeper": "Viper ROS1300 Rider Floor Sweeper w/ Dust Control - 53\" Sweeping Path — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-tennant-t500e-26-inch-walk-behind-floor-scrubber": "Tennant® T500e Self-Propelled 26\" Walk Behind Automatic Floor Scrubber w/ Pad Dr — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-advance-sc750-28-inch-battery-floor-scrubber-w-pad-holders": "Advance® SC750™ 28\" Battery Floor Scrubber w/ Pad Holders — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-advance-sc901-28-inch-commercial-battery-floor-scrubber-w-pad-driver": "Advance® SC901™ 28\" Commercial Battery Floor Scrubber w/ Pad Driver — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-clarke-focus-boost-28-inch-orbital-auto-scrubber": "Clarke® Focus® II Boost® 14\" x 28\" Orbital Auto Floor Scrubber — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-pacific-floorcare-s-28-orbital-floor-scrubber-14x28": "Pacific Floorcare® S-28 Orbital Automatic Floor Scrubber (22 Gallons) - 14\" x 28 — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-pacific-floorcare-32-inch-battery-powered-s-32-auto-scrubber": "Pacific Floorcare® 32\" Battery Powered S-32 Auto Scrubber (22 Gallon) w/ Pad Dri — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-tornado-bd-26-27-rider-auto-scrubber-w-pad-drivers-27-gallons": "Tornado® BD 26/27 Rider Auto Scrubber w/ Pad Drivers - 27 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-ipc-eagle-24-in-ride-on-automatic-floor-scrubber-ct80-series": "IPC Eagle CT80 Compact Ride on Automatic Floor Scrubber (24\" Scrub Deck) - 21 Ga — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-advance-sc750-st-26-inch-battery-floor-scrubber": "Advance® SC750™ ST 26\" Battery Floor Scrubber w/ Pad Holders — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-pacific-floorcare-28-inch-battery-powered-s-28-floor-scrubber": "Pacific Floorcare® 28\" Battery Powered S-28 Floor Scrubber (22 Gallon) w/ Pad Dr — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-viper-as7190to-walk-behind-orbital-automatic-floor-scrubber-w-traction-drive": "Viper AS7190TO Walk Behind Orbital Automatic Floor Scrubber (14\" x 28\" Head) w/  — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-nilfisk-sc550-cylindrical-floor-scrubber-li-ion-battery": "Nilfisk® SC550 Cylindrical 20\" Floor Scrubber w/ Li-ion Battery - 13 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-40-inch-dust-control-propane-burnisher": "Pioneer Eclipse High Speed 40\" Propane Floor Burnisher w/ 18 HP Kawasaki Enigine — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-advance-adfinity-x20c-cylindrical-battery-floor-scrubber-with-ecoflex": "Advance® Adfinity™ X20C Cylindrical 20\" Battery Floor Scrubber w/ EcoFlex™ - 14. — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-minuteman-max-ride-26-automatic-floor-scrubber": "Minuteman® Max Ride 26 Automatic Floor Scrubber (Battery Upgrade Option Availabl — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-advance-sc1500-commercial-20-inch-stand-up-floor-scrubber": "Advance® SC1500™ Commercial 20\" Stand-On Floor Scrubber w/ EcoFlex™ & Optional R — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-cleanfreak-4-gpm-trailer-mount-pressure-washer-with-tank-and-100-foot-hose": "CleanFreak® 4.0 GPM Hot Water Pressure Washing Skid w/ Tank, Reels & Spray Gun ( — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-pioneer-eclipse-315asr-30-inch-ride-on-floor-scrubber": "Pioneer Eclipse 315ASR 30\" Ride On Floor Scrubber — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-viper-32-inch-auto-scrubber": "Viper Fang 32 inch Automatic Floor Scrubber — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-clarke-focus-boost-28-inch-orbital-auto-scrubber-demo": "Clarke® Focus® II Boost® 28 inch Orbital Auto Scrubber (Refurbished) — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-viper-as7690t-walk-behind-30-inch-automatic-floor-scrubber": "Viper AS7690T Walk Behind 30\" Automatic Floor Scrubber - 22 Gallon — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-3040qh-hot-water-gas-pressure-washer-cs-3040qh": "3040QH Hot Water Gas Pressure Washer — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-clarke-ca60-24b-boost-automatic-floor-scrubber-14x24-inch-head": "Clarke® CA60 24B Boost® Orbital Automatic Floor Scrubber - 14\" x 24\" Head — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-top-stripping-orbital-auto-scrubber": "Pacific Floorcare® S-20 Orbital Auto Scrubber - 14\" x 20\" — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-viper-as530r-ride-on-auto-floor-scrubber-no-batteries-20-cleaning-path-vp-50000417": "Viper AS530R Ride On Auto Floor Scrubber - No Batteries - 20\" Cleaning Path — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-viper-as6690t-walk-behind-26-inch-automatic-floor-scrubber": "Viper AS6690T Walk Behind 26\" Automatic Floor Scrubber - 22 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-pacific-floorcare-s-20-automatic-floor-scrubber": "Pacific Floorcare® 20\" Automatic Floor Scrubber (#S-20) - Traction Drive w/ Batt — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-battery-powered-gas-station-sweeper": "IPC Eagle 712ET Battery Powered 36\" Vacuum Sweeper — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-26-inch-tornado-floor-scrubbing-machine": "Tornado® 28\" BD 28/20 Automatic Floor Scrubber - 20 Gallon — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-pioneer-eclipse-20-inch-300bu-battery-floor-burnisher": "Pioneer Eclipse 20\" 300BU Ultra-High Speed (UHS) Battery Floor Burnisher - 2,000 — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-large-carpet-area-self-contained-carpet-cleaning-extractor-machine-mm-c8420-115": "Large Carpet Area Self-Contained Carpet Cleaning Extractor Machine — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-microfiber-bonnet-auto-floor-scrubber": "IPC Eagle CT70 ECS 28\" Auto Floor Scrubber w/ Microfiber Bonnet Drivers - 19 Gal — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-eco-stripping-orbital-auto-scrubber-package": "Clarke® Boost® 14\" x 20\" Oscillating Auto Scrubber Floor Stripping Package — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-pioneer-eclipse-24-inch-propane-burnisher": "Pioneer Eclipse 24\" Propane Floor Burnisher w/ Dust Control & Emissions Monitori — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-compact-rider-sweeper-ipc-eagle-512r": "IPC Eagle 512R Compact Industrial Rider Floor & Carpet Vacuum Sweeper - 28\" Swee — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-ipc-eagle-ct71xp-600-rpm-high-speed-28-automatic-floor-polisher-and-scrubber-19-gallons": "IPC Eagle CT71XP 600 RPM High Speed 28\" Automatic Floor Polisher & Scrubber w/ P — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-advance-sc2000-20-inch-compact-ride-on-floor-scrubber": "Advance® SC2000™ 20\" Compact Ride-on Floor Scrubber w/ Pad Drivers - 18.5 Gallon — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-tennant-t581-micro-20-inch-ride-on-floor-scrubber": "Tennant® T581 Micro 20\" Ride-On Floor Scrubber w/ Pad Driver - 20 Gallons — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-clarke-ra40-20d-micro-rider-scrubber": "Clarke® RA40™ 20D Rider Floor Scrubber w/ Pad Driver (20\" Scrub Deck) - 18.5 Gal — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-ipc-eagle-ct71-traction-drive-automatic-floor-scrubber-24-or-28-inch": "IPC Eagle CT71 Traction Drive Automatic Floor Scrubber w/ Pad Drivers (24\" & 28\" — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-minuteman-h26-hospital-floor-scrubber": "Minuteman® H26 Compact Automatic Floor Scrubber for Hospitals w/ Pad Drivers - 1 — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-ipc-eagle-ct51xp-600-rpm-high-speed-28-inch-automatic-floor-polisher-and-scrubber-13-gallo": "IPC Eagle CT51XP 600 RPM High Speed 28\" Automatic Floor Polisher & Scrubber w/ P — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-minuteman-26-inch-self-propelled-battery-floor-scrubber": "Minuteman® 26\" Self Propelled Battery Floor Scrubber w/ Pad Drivers — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-powr-flite-crossover-26-inch-rider-automatic-floor-scrubber-pas26r": "Powr-Flite® Crossover 26\" Rider Automatic Floor Scrubber w/ Pad Drivers (#PAS26R — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-pacific-floorcare-s-24xm-24-inch-battery-powered-floor-scrubber-11-gallon": "Pacific Floorcare® S-24XM 24\" Battery Powered Floor Scrubber (11 Gallon) w/ Pad  — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-tennant-t390-self-propelled-28-inch-floor-scrubber": "Tennant® T390 Self-Propelled 28\" Walk Behind Automatic Floor Scrubber w/ Pad Dri — commercial equipment from The Cleaning Business. Request a quote for freight and configuration.",
  "machine-viper-as530r-micro-rider-floor-scrubber": "Viper AS530R™ Micro Rider Floor Scrubber w/ Pad Driver (20\" Scrub Deck) - 19 Gal — commercial equipment from The Cleaning Business. Request a quote for freight and configuration."
};

window.TCB_FINDER_DATA.packageDescriptions = {
  "packages-hub": "Start here when you need a full custom package with machines, supplies, chemicals, parts, and expert support.",
  "school-cleaning-packages": "School Cleaning Packages for commercial cleaning buyers.",
  "package-school-starter-cleaning-package": "School buyers focused on classrooms, hallways, restrooms and repeatable commercial cleaning routines.",
  "package-school-hallway-floor-scrubber-package": "School buyers focused on classrooms, hallways, restrooms and repeatable commercial cleaning routines.",
  "package-school-restroom-cleaning-package": "School buyers focused on classrooms, hallways, restrooms and repeatable commercial cleaning routines.",
  "package-school-full-facility-package": "School buyers focused on classrooms, hallways, restrooms and repeatable commercial cleaning routines.",
  "church-cleaning-packages": "Church Cleaning Packages for commercial cleaning buyers.",
  "package-church-starter-cleaning-package": "Church buyers focused on sanctuary, fellowship hall, restrooms and repeatable commercial cleaning routines.",
  "package-sanctuary-vacuum-floor-care-package": "Church buyers focused on sanctuary, fellowship hall, restrooms and repeatable commercial cleaning routines.",
  "package-church-full-facility-package": "Church buyers focused on sanctuary, fellowship hall, restrooms and repeatable commercial cleaning routines.",
  "gym-cleaning-packages": "Gym Cleaning Packages for commercial cleaning buyers.",
  "package-rubber-floor-cleaning-package": "Gym buyers focused on rubber floors, weight room, cardio area and repeatable commercial cleaning routines.",
  "package-locker-room-restroom-cleaning-package": "Gym buyers focused on locker rooms, weight room, cardio area and repeatable commercial cleaning routines.",
  "package-gym-full-facility-package": "Gym buyers focused on weight room, cardio area, locker rooms and repeatable commercial cleaning routines.",
  "restaurant-cleaning-packages": "Restaurant Cleaning Packages for commercial cleaning buyers.",
  "package-commercial-kitchen-degreasing-package": "Restaurant buyers focused on kitchen, dining room, restrooms and repeatable commercial cleaning routines.",
  "package-restaurant-floor-scrubber-package": "Restaurant buyers focused on kitchen, dining room, restrooms and repeatable commercial cleaning routines.",
  "package-restaurant-full-facility-package": "Restaurant buyers focused on kitchen, dining room, restrooms and repeatable commercial cleaning routines.",
  "warehouse-cleaning-packages": "Warehouse Cleaning Packages for commercial cleaning buyers.",
  "package-concrete-floor-scrubber-package": "Warehouse buyers focused on aisles, loading docks, packing areas and repeatable commercial cleaning routines.",
  "package-warehouse-sweeper-package": "Warehouse buyers focused on aisles, loading docks, packing areas and repeatable commercial cleaning routines.",
  "warehouse-wet-dry-vacuum-package": "Best for wet spills, dry debris, docks, restrooms, and versatile warehouse cleanup routes.",
  "package-warehouse-full-facility-package": "Warehouse buyers focused on aisles, loading docks, packing areas and repeatable commercial cleaning routines.",
  "hotel-cleaning-packages": "Hotel & Property Cleaning Packages for commercial cleaning buyers.",
  "package-hotel-carpet-extractor-package": "Carpet Extractor buyers focused on offices, hotels, churches and repeatable commercial cleaning routines.",
  "package-housekeeping-cart-package": "Hotel & Property buyers focused on lobby, hallways, guest rooms and repeatable commercial cleaning routines.",
  "package-hotel-full-facility-package": "Hotel & Property buyers focused on lobby, hallways, guest rooms and repeatable commercial cleaning routines.",
  "property-manager-cleaning-packages": "Property Manager Cleaning Packages for commercial cleaning buyers.",
  "package-apartment-turnover-cleaning-package": "Property Manager buyers focused on apartments, leasing office, hallways and repeatable commercial cleaning routines.",
  "package-property-carpet-cleaning-package": "Property Manager buyers focused on apartments, leasing office, hallways and repeatable commercial cleaning routines.",
  "package-full-property-manager-package": "Property Manager buyers focused on apartments, leasing office, hallways and repeatable commercial cleaning routines.",
  "office-cleaning-packages": "Office Building Cleaning Packages for commercial cleaning buyers.",
  "package-office-vacuum-package": "Office Building buyers focused on lobby, workstations, conference rooms and repeatable commercial cleaning routines.",
  "package-office-restroom-cleaning-package": "Office Building buyers focused on lobby, workstations, conference rooms and repeatable commercial cleaning routines.",
  "package-office-full-facility-package": "Office Building buyers focused on lobby, workstations, conference rooms and repeatable commercial cleaning routines.",
  "healthcare-cleaning-packages": "Healthcare Cleaning Packages for commercial cleaning buyers.",
  "package-clinic-cleaning-package": "Healthcare buyers focused on waiting rooms, exam areas, patient rooms and repeatable commercial cleaning routines.",
  "package-healthcare-restroom-cleaning-package": "Healthcare buyers focused on waiting rooms, exam areas, patient rooms and repeatable commercial cleaning routines.",
  "package-healthcare-full-facility-package": "Healthcare buyers focused on waiting rooms, exam areas, patient rooms and repeatable commercial cleaning routines.",
  "contractor-cleaning-packages": "Janitorial Contractor Packages for commercial cleaning buyers.",
  "package-contractor-starter-package": "Janitorial Contractor buyers focused on office routes, schools, churches and repeatable commercial cleaning routines.",
  "package-contractor-carpet-cleaning-package": "Janitorial Contractor buyers focused on carpet jobs, office routes, schools and repeatable commercial cleaning routines.",
  "package-contractor-full-route-package": "Janitorial Contractor buyers focused on office routes, schools, churches and repeatable commercial cleaning routines.",
  "starter-business-packages": "Cleaning Business Starter Packages for commercial cleaning buyers.",
  "package-solo-cleaner-starter-package": "Cleaning Business Starter buyers focused on first accounts, offices, restrooms and repeatable commercial cleaning routines.",
  "package-first-commercial-account-package": "Cleaning Business Starter buyers focused on first accounts, offices, restrooms and repeatable commercial cleaning routines.",
  "package-complete-cleaning-business-launch-package": "Cleaning Business Starter buyers focused on first accounts, offices, restrooms and repeatable commercial cleaning routines.",
  "carpet-extractor-packages": "Carpet Extractor Packages for commercial cleaning buyers.",
  "package-carpet-extractor-starter-package": "Carpet Extractor buyers focused on offices, hotels, churches and repeatable commercial cleaning routines.",
  "package-heated-extractor-package": "Carpet Extractor buyers focused on offices, hotels, churches and repeatable commercial cleaning routines.",
  "floor-scrubber-packages": "Floor Scrubber Packages for commercial cleaning buyers.",
  "package-floor-scrubber-starter-package": "Floor Scrubber buyers focused on hard floors, warehouses, schools and repeatable commercial cleaning routines.",
  "package-medium-facility-scrubber-package": "Floor Scrubber buyers focused on hard floors, warehouses, schools and repeatable commercial cleaning routines.",
  "package-gym-scrubber-package": "Floor Scrubber buyers focused on hard floors, warehouses, schools and repeatable commercial cleaning routines.",
  "package-cleanfreak-17-scrubber": "CleanFreak 17 inch auto scrubber package for hard-floor cleaning teams. This page is designed for commercial buyers who want a practical starting point instead of piecing together every item from scratch. The Cleaning Business can help you confirm machine fit, accessories, chemic",
  "package-mytee-2008cs-extractor": "Mytee 2008CS heated extractor package for carpet cleaning and upholstery jobs. This page is designed for commercial buyers who want a practical starting point instead of piecing together every item from scratch. The Cleaning Business can help you confirm machine fit, accessories,",
  "package-mytee-220-hose-extractor": "Mytee 220 PSI extractor with 25 foot hose package for portable carpet cleaning. This page is designed for commercial buyers who want a practical starting point instead of piecing together every item from scratch. The Cleaning Business can help you confirm machine fit, accessories",
  "package-trusted-clean-maximum-contractor": "Trusted Clean contractor carpet cleaning package for route-based cleaning businesses. This page is designed for commercial buyers who want a practical starting point instead of piecing together every item from scratch. The Cleaning Business can help you confirm machine fit, acces",
  "package-clarke-boost-stripping": "Clarke Boost orbital stripping package for floor care crews. This page is designed for commercial buyers who want a practical starting point instead of piecing together every item from scratch. The Cleaning Business can help you confirm machine fit, accessories, chemicals, freigh",
  "package-cleanfreak-performer-20": "CleanFreak Performer 20 hard-surface floor scrubber package. This page is designed for commercial buyers who want a practical starting point instead of piecing together every item from scratch. The Cleaning Business can help you confirm machine fit, accessories, chemicals, freigh",
  "package-contractor-facility": "Contractor cleaning equipment collection for multi-account janitorial routes. This page is designed for commercial buyers who want a practical starting point instead of piecing together every item from scratch. The Cleaning Business can help you confirm machine fit, accessories, ",
  "package-warehouse-facility": "Warehouse cleaning equipment collection for concrete floors, dust, and debris. This page is designed for commercial buyers who want a practical starting point instead of piecing together every item from scratch. The Cleaning Business can help you confirm machine fit, accessories,",
  "package-school-facility": "School and church cleaning equipment collection for halls, restrooms, and common areas. This page is designed for commercial buyers who want a practical starting point instead of piecing together every item from scratch. The Cleaning Business can help you confirm machine fit, acc",
  "package-hotel-facility": "Hotel and property cleaning equipment collection for carpets, rooms, lobbies, and turnover work. This page is designed for commercial buyers who want a practical starting point instead of piecing together every item from scratch. The Cleaning Business can help you confirm machine",
  "package-healthcare-facility": "Healthcare facility cleaning equipment collection for patient-facing environments. This page is designed for commercial buyers who want a practical starting point instead of piecing together every item from scratch. The Cleaning Business can help you confirm machine fit, accessor",
  "package-starter-business": "Starter cleaning business package collection for first commercial accounts. This page is designed for commercial buyers who want a practical starting point instead of piecing together every item from scratch. The Cleaning Business can help you confirm machine fit, accessories, ch",
  "package-carpet-extractor-starter": "Carpet extractor starter collection for carpet cleaning teams. This page is designed for commercial buyers who want a practical starting point instead of piecing together every item from scratch. The Cleaning Business can help you confirm machine fit, accessories, chemicals, frei",
  "package-floor-scrubber-starter": "Floor scrubber starter collection for hard-floor care teams. This page is designed for commercial buyers who want a practical starting point instead of piecing together every item from scratch. The Cleaning Business can help you confirm machine fit, accessories, chemicals, freigh",
  "package-classroom-daily-cleaning-package": "School buyers focused on classrooms, hallways, restrooms and repeatable commercial cleaning routines.",
  "package-school-cafeteria-cleaning-package": "School buyers focused on cafeteria, classrooms, hallways and repeatable commercial cleaning routines.",
  "package-school-gym-floor-cleaning-package": "School buyers focused on gym, classrooms, hallways and repeatable commercial cleaning routines.",
  "package-school-carpet-office-cleaning-package": "School buyers focused on classrooms, hallways, restrooms and repeatable commercial cleaning routines.",
  "package-school-maintenance-parts-refill-package": "School buyers focused on classrooms, hallways, restrooms and repeatable commercial cleaning routines.",
  "package-school-summer-deep-cleaning-package": "School buyers focused on classrooms, hallways, restrooms and repeatable commercial cleaning routines.",
  "package-fellowship-hall-cleaning-package": "Church buyers focused on fellowship hall, sanctuary, restrooms and repeatable commercial cleaning routines.",
  "package-church-restroom-cleaning-package": "Church buyers focused on sanctuary, fellowship hall, restrooms and repeatable commercial cleaning routines.",
  "package-church-carpet-cleaning-package": "Church buyers focused on sanctuary, fellowship hall, restrooms and repeatable commercial cleaning routines.",
  "package-church-event-cleanup-package": "Church buyers focused on event areas, sanctuary, fellowship hall and repeatable commercial cleaning routines.",
  "package-church-volunteer-friendly-cleaning-package": "Church buyers focused on sanctuary, fellowship hall, restrooms and repeatable commercial cleaning routines.",
  "package-church-maintenance-storage-package": "Church buyers focused on sanctuary, fellowship hall, restrooms and repeatable commercial cleaning routines.",
  "package-church-budget-cleaning-package": "Church buyers focused on sanctuary, fellowship hall, restrooms and repeatable commercial cleaning routines.",
  "package-gym-starter-cleaning-package": "Gym buyers focused on weight room, cardio area, locker rooms and repeatable commercial cleaning routines.",
  "package-weight-room-disinfection-package": "Gym buyers focused on weight room, cardio area, locker rooms and repeatable commercial cleaning routines.",
  "package-cardio-area-cleaning-package": "Gym buyers focused on cardio area, weight room, locker rooms and repeatable commercial cleaning routines.",
  "package-gym-odor-control-package": "Gym buyers focused on weight room, cardio area, locker rooms and repeatable commercial cleaning routines.",
  "package-gym-floor-scrubber-package": "Gym buyers focused on rubber floors, weight room, cardio area and repeatable commercial cleaning routines.",
  "package-gym-microfiber-spray-system-package": "Gym buyers focused on weight room, cardio area, locker rooms and repeatable commercial cleaning routines.",
  "package-gym-maintenance-parts-package": "Gym buyers focused on weight room, cardio area, locker rooms and repeatable commercial cleaning routines.",
  "package-restaurant-starter-cleaning-package": "Restaurant buyers focused on kitchen, dining room, restrooms and repeatable commercial cleaning routines.",
  "package-dining-room-cleaning-package": "Restaurant buyers focused on dining room, kitchen, restrooms and repeatable commercial cleaning routines.",
  "package-restaurant-restroom-cleaning-package": "Restaurant buyers focused on kitchen, dining room, restrooms and repeatable commercial cleaning routines.",
  "package-restaurant-wet-dry-vacuum-package": "Restaurant buyers focused on kitchen, dining room, restrooms and repeatable commercial cleaning routines.",
  "package-restaurant-closing-shift-cleaning-package": "Restaurant buyers focused on kitchen, dining room, restrooms and repeatable commercial cleaning routines.",
  "package-restaurant-grease-control-package": "Restaurant buyers focused on kitchen, dining room, restrooms and repeatable commercial cleaning routines.",
  "package-restaurant-safety-wet-floor-package": "Restaurant buyers focused on kitchen, dining room, restrooms and repeatable commercial cleaning routines.",
  "package-warehouse-starter-cleaning-package": "Warehouse buyers focused on aisles, loading docks, packing areas and repeatable commercial cleaning routines.",
  "package-warehouse-dust-debris-package": "Warehouse buyers focused on aisles, loading docks, packing areas and repeatable commercial cleaning routines.",
  "package-loading-dock-cleaning-package": "Warehouse buyers focused on loading docks, aisles, packing areas and repeatable commercial cleaning routines.",
  "package-warehouse-wet-dry-vacuum-package": "Warehouse buyers focused on aisles, loading docks, packing areas and repeatable commercial cleaning routines.",
  "package-warehouse-heavy-duty-floor-care-package": "Warehouse buyers focused on aisles, loading docks, packing areas and repeatable commercial cleaning routines.",
  "package-warehouse-maintenance-parts-package": "Warehouse buyers focused on aisles, loading docks, packing areas and repeatable commercial cleaning routines.",
  "package-warehouse-safety-spill-response-package": "Warehouse buyers focused on aisles, loading docks, packing areas and repeatable commercial cleaning routines.",
  "package-hotel-starter-cleaning-package": "Hotel & Property buyers focused on lobby, hallways, guest rooms and repeatable commercial cleaning routines.",
  "package-hotel-hallway-lobby-package": "Hotel & Property buyers focused on lobby, hallways, guest rooms and repeatable commercial cleaning routines.",
  "package-guest-room-cleaning-package": "Hotel & Property buyers focused on guest rooms, lobby, hallways and repeatable commercial cleaning routines.",
  "package-hotel-restroom-cleaning-package": "Hotel & Property buyers focused on lobby, hallways, guest rooms and repeatable commercial cleaning routines.",
  "package-odor-control-package": "Hotel & Property buyers focused on lobby, hallways, guest rooms and repeatable commercial cleaning routines.",
  "package-property-turnover-cleaning-package": "Hotel & Property buyers focused on lobby, hallways, guest rooms and repeatable commercial cleaning routines.",
  "package-hotel-maintenance-parts-package": "Hotel & Property buyers focused on lobby, hallways, guest rooms and repeatable commercial cleaning routines.",
  "package-property-common-area-cleaning-package": "Property Manager buyers focused on common areas, apartments, leasing office and repeatable commercial cleaning routines.",
  "package-leasing-office-cleaning-package": "Property Manager buyers focused on leasing office, apartments, hallways and repeatable commercial cleaning routines.",
  "package-property-hallway-floor-care-package": "Property Manager buyers focused on apartments, leasing office, hallways and repeatable commercial cleaning routines.",
  "package-move-in-move-out-cleaning-package": "Property Manager buyers focused on apartments, leasing office, hallways and repeatable commercial cleaning routines.",
  "package-property-restroom-cleaning-package": "Property Manager buyers focused on apartments, leasing office, hallways and repeatable commercial cleaning routines.",
  "package-multi-building-cleaning-package": "Property Manager buyers focused on apartments, leasing office, hallways and repeatable commercial cleaning routines.",
  "package-property-maintenance-parts-package": "Property Manager buyers focused on apartments, leasing office, hallways and repeatable commercial cleaning routines.",
  "package-office-starter-cleaning-package": "Office Building buyers focused on lobby, workstations, conference rooms and repeatable commercial cleaning routines.",
  "package-office-lobby-floor-care-package": "Office Building buyers focused on lobby, workstations, conference rooms and repeatable commercial cleaning routines.",
  "package-office-carpet-cleaning-package": "Office Building buyers focused on lobby, workstations, conference rooms and repeatable commercial cleaning routines.",
  "package-office-trash-touchpoint-package": "Office Building buyers focused on lobby, workstations, conference rooms and repeatable commercial cleaning routines.",
  "package-office-hard-floor-scrubber-package": "Office Building buyers focused on lobby, workstations, conference rooms and repeatable commercial cleaning routines.",
  "package-office-maintenance-parts-package": "Office Building buyers focused on lobby, workstations, conference rooms and repeatable commercial cleaning routines.",
  "package-corporate-janitorial-package": "Office Building buyers focused on lobby, workstations, conference rooms and repeatable commercial cleaning routines.",
  "package-healthcare-starter-cleaning-package": "Healthcare buyers focused on waiting rooms, exam areas, patient rooms and repeatable commercial cleaning routines.",
  "package-patient-area-cleaning-package": "Healthcare buyers focused on patient rooms, waiting rooms, exam areas and repeatable commercial cleaning routines.",
  "package-waiting-room-cleaning-package": "Healthcare buyers focused on waiting rooms, exam areas, patient rooms and repeatable commercial cleaning routines.",
  "package-healthcare-floor-care-package": "Healthcare buyers focused on waiting rooms, exam areas, patient rooms and repeatable commercial cleaning routines.",
  "package-healthcare-microfiber-system-package": "Healthcare buyers focused on waiting rooms, exam areas, patient rooms and repeatable commercial cleaning routines.",
  "package-healthcare-safety-ppe-package": "Healthcare buyers focused on waiting rooms, exam areas, patient rooms and repeatable commercial cleaning routines.",
  "package-healthcare-maintenance-parts-package": "Healthcare buyers focused on waiting rooms, exam areas, patient rooms and repeatable commercial cleaning routines.",
  "package-contractor-office-route-package": "Janitorial Contractor buyers focused on office routes, schools, churches and repeatable commercial cleaning routines.",
  "package-contractor-school-church-route-package": "Janitorial Contractor buyers focused on office routes, schools, churches and repeatable commercial cleaning routines.",
  "package-contractor-restaurant-route-package": "Janitorial Contractor buyers focused on office routes, schools, churches and repeatable commercial cleaning routines.",
  "package-contractor-floor-scrubber-package": "Janitorial Contractor buyers focused on office routes, schools, churches and repeatable commercial cleaning routines.",
  "package-contractor-multi-surface-package": "Janitorial Contractor buyers focused on office routes, schools, churches and repeatable commercial cleaning routines.",
  "package-contractor-replacement-parts-package": "Janitorial Contractor buyers focused on office routes, schools, churches and repeatable commercial cleaning routines.",
  "package-contractor-van-ready-equipment-package": "Janitorial Contractor buyers focused on office routes, schools, churches and repeatable commercial cleaning routines.",
  "package-office-cleaning-startup-package": "Cleaning Business Starter buyers focused on first accounts, offices, restrooms and repeatable commercial cleaning routines.",
  "package-floor-care-startup-package": "Cleaning Business Starter buyers focused on first accounts, offices, restrooms and repeatable commercial cleaning routines.",
  "package-carpet-cleaning-startup-package": "Cleaning Business Starter buyers focused on carpet areas, first accounts, offices and repeatable commercial cleaning routines.",
  "package-janitorial-cart-startup-package": "Cleaning Business Starter buyers focused on first accounts, offices, restrooms and repeatable commercial cleaning routines.",
  "package-budget-startup-package": "Cleaning Business Starter buyers focused on first accounts, offices, restrooms and repeatable commercial cleaning routines.",
  "package-professional-startup-package": "Cleaning Business Starter buyers focused on first accounts, offices, restrooms and repeatable commercial cleaning routines.",
  "package-contractor-growth-package": "Cleaning Business Starter buyers focused on first accounts, offices, restrooms and repeatable commercial cleaning routines.",
  "package-office-carpet-extractor-package": "Carpet Extractor buyers focused on offices, hotels, churches and repeatable commercial cleaning routines.",
  "package-church-carpet-extractor-package": "Carpet Extractor buyers focused on offices, hotels, churches and repeatable commercial cleaning routines.",
  "package-property-manager-carpet-package": "Carpet Extractor buyers focused on offices, hotels, churches and repeatable commercial cleaning routines.",
  "package-auto-detailing-extractor-package": "Carpet Extractor buyers focused on auto interiors, offices, hotels and repeatable commercial cleaning routines.",
  "package-high-psi-extractor-package": "Carpet Extractor buyers focused on offices, hotels, churches and repeatable commercial cleaning routines.",
  "package-extractor-hose-wand-package": "Carpet Extractor buyers focused on offices, hotels, churches and repeatable commercial cleaning routines.",
  "package-extractor-maintenance-parts-package": "Carpet Extractor buyers focused on offices, hotels, churches and repeatable commercial cleaning routines.",
  "package-small-facility-scrubber-package": "Floor Scrubber buyers focused on hard floors, warehouses, schools and repeatable commercial cleaning routines.",
  "package-large-facility-scrubber-package": "Floor Scrubber buyers focused on hard floors, warehouses, schools and repeatable commercial cleaning routines.",
  "package-warehouse-scrubber-package": "Floor Scrubber buyers focused on hard floors, warehouses, schools and repeatable commercial cleaning routines.",
  "package-school-scrubber-package": "Floor Scrubber buyers focused on hard floors, warehouses, schools and repeatable commercial cleaning routines.",
  "package-restaurant-scrubber-package": "Floor Scrubber buyers focused on hard floors, warehouses, schools and repeatable commercial cleaning routines.",
  "package-scrubber-pads-chemicals-package": "Floor Scrubber buyers focused on hard floors, warehouses, schools and repeatable commercial cleaning routines.",
  "package-scrubber-maintenance-parts-package": "Floor Scrubber buyers focused on hard floors, warehouses, schools and repeatable commercial cleaning routines."
};
